/* Конторские экраны, латиница. Ключ — русская фраза.

   Собирается из партий tr-*.cjs в tools/i18n; править здесь
   бессмысленно, правка потеряется при следующей сборке.
   Устройство и причина такого ключа — в office.js.

   ТРЕБУЕТ ВЫЧИТКИ НОСИТЕЛЕМ НА ЗАВОДЕ ДО ЗАПУСКА. */

export default {
  'Отмена': 'Bekor qilish',
  'Обновить': 'Yangilash',
  'Партия': 'Partiya',
  'Материал': 'Material',
  'Закрыть': 'Yopish',
  'Заказ': 'Buyurtma',
  'Изделие': 'Mahsulot',
  'Название': 'Nomi',
  '— выберите —': '— tanlang —',
  'Когда': 'Qachon',
  'Код': 'Kod',
  'Причина': 'Sabab',
  'Станок': 'Dastgoh',
  'Вид': 'Turi',
  'Кто': 'Kim',
  'Оборудование': 'Uskuna',
  'Примечание': 'Eslatma',
  'Состояние': 'Holat',
  '— выберите материал —': '— materialni tanlang —',
  'Включить': 'Yoqish',
  'загрузка…': 'yuklanmoqda…',
  'Качество': 'Sifat',
  'Количество': 'Miqdor',
  'Номер': 'Raqam',
  'отключён': 'o‘chirilgan',
  'Отключить': 'O‘chirish',
  'Пометка': 'Belgi',
  'Правка': 'Tahrirlash',
  'Срок': 'Muddat',
  'Убрать': 'Olib tashlash',
  'Уровень': 'Daraja',
  'Готово': 'Tayyor',
  'Дата': 'Sana',
  'Добавить': 'Qo‘shish',
  'Документ продаж': 'Sotuv hujjati',
  'Доступность': 'Mavjudlik',
  'Ед.': 'Birl.',
  'Завести': 'Kiritish',
  'Загрузка…': 'Yuklanmoqda…',
  'Заказы': 'Buyurtmalar',
  'Комментарий': 'Izoh',
  'Не более': 'Ko‘pi bilan',
  'Не менее': 'Kami bilan',
  'Операция': 'Operatsiya',
  'Осталось': 'Qoldi',
  'Откуда': 'Qayerdan',
  'Показатель': 'Ko‘rsatkich',
  'показывать отключённые': 'o‘chirilganlarni ko‘rsatish',
  'Применить': 'Qo‘llash',
  'Производительность': 'Unumdorlik',
  'Происхождение': 'Kelib chiqishi',
  'Сертификат': 'Sertifikat',
  'Смена': 'Smena',
  'Смены': 'Smenalar',
  'Станки': 'Dastgohlar',
  'Статус': 'Status',
  'Сторно': 'Storno',
  'Уровень качества': 'Sifat darajasi',
  'Участок': 'Uchastka',
  '— не присвоен —': '— berilmagan —',
  '· события недоступны': '· hodisalar mavjud emas',
  'аннулирован': 'kuchdan qoldirilgan',
  'Аннулировать': 'Kuchdan qoldirish',
  'Брак': 'Yaroqsiz',
  'В работе': 'Ishda',
  'В цехе': 'Sexda',
  'Вс': 'Yak',
  'Вт': 'Se',
  'Входной материал': 'Kiruvchi material',
  'Выдать': 'Berish',
  'да': 'ha',
  'Единица': 'Birlik',
  'Заказчик': 'Buyurtmachi',
  'Записать': 'Yozish',
  'Календарь': 'Kalendar',
  'Кол-во': 'Miqd.',
  'Контрагент': 'Kontragent',
  'Куда': 'Qayerga',
  'Материалы': 'Materiallar',
  'на партию': 'partiyaga',
  'Направление': 'Yo‘nalish',
  'Настройка': 'Sozlash',
  'Не установлено': 'O‘rnatilmagan',
  'Номер партии': 'Partiya raqami',
  'Номер сертификата': 'Sertifikat raqami',
  'Операции': 'Operatsiyalar',
  'Оснастка и инструмент': 'Asbob va uskuna',
  'Перевыпустить': 'Qayta chiqarish',
  'Перевыпустить токен': 'Tokenni qayta chiqarish',
  'План': 'Reja',
  'Плановое время': 'Rejadagi vaqt',
  'Пн': 'Du',
  'Позиция': 'Pozitsiya',
  'Порядок': 'Tartib',
  'Порядок в списке': 'Ro‘yxatdagi tartib',
  'Последний раз': 'Oxirgi marta',
  'Поставщик': 'Yetkazib beruvchi',
  'Предприятие': 'Korxona',
  'Предъявлено': 'Taqdim etilgan',
  'Предыдущий передел': 'Oldingi bosqich',
  'Принято': 'Qabul qilingan',
  'Приоритет': 'Ustuvorlik',
  'Прогресс': 'Bajarilishi',
  'Продукция': 'Mahsulot',
  'Производство': 'Ishlab chiqarish',
  'Прошло маршрут до конца': 'Marshrutni oxirigacha o‘tdi',
  'Пт': 'Jum',
  'Сб': 'Sha',
  'Свой передел': 'O‘z bosqichi',
  'Сколько': 'Qancha',
  'Сохранить': 'Saqlash',
  'Ср': 'Cho',
  'Сторнировать': 'Storno qilish',
  'Табельный': 'Tabel',
  'Такт, сек/ед': 'Takt, sek/birl.',
  'Тара под лом': 'Chiqindi idishi',
  'Тип': 'Turi',
  'Фактически': 'Amalda',
  'Химия плавки': 'Eritma kimyosi',
  'Чт': 'Pay',
  'Что это': 'Bu nima',
  '— аннулирован': '— kuchdan qoldirilgan',
  '— без сертификата —': '— sertifikatsiz —',
  '— вид операции —': '— operatsiya turi —',
  '— выберите зону —': '— zonani tanlang —',
  '— выберите партию —': '— partiyani tanlang —',
  '— выберите регламент —': '— reglamentni tanlang —',
  '— выберите станок —': '— dastgohni tanlang —',
  '— не задан —': '— berilmagan —',
  '— не задано —': '— berilmagan —',
  '— не назначен': '— tayinlanmagan',
  '— не присвоено —': '— berilmagan —',
  '— не указана —': '— ko‘rsatilmagan —',
  '— обязателен для этой причины': '— bu sabab uchun majburiy',
  '— обязательна': '— majburiy',
  '— оператор выбирает сам —': '— operator o‘zi tanlaydi —',
  '— поправьте, иначе событие по ним будет отклонено': '— to‘g‘rilang, aks holda ular bo‘yicha hodisa rad etiladi',
  '— при необходимости': '— zarur bo‘lsa',
  '— причина —': '— sabab —',
  '— тип не меняется: у узла есть потомки и привязанные данные': '— turi o‘zgarmaydi: tugunda avlodlar va bog‘langan ma’lumotlar bor',
  '— участок не задан —': '— uchastka berilmagan —',
  '— фактических данных пока нет, считаем по нормативу': '— amaldagi ma’lumotlar hali yo‘q, norma bo‘yicha hisoblanmoqda',
  '. На столько дата и сдвинулась.': '. Sana ham shunchaga surildi.',
  '· без документа продаж': '· sotuv hujjatisiz',
  '· ждут': '· kutmoqda',
  '· норматив завышен либо не учтено время работы': '· norma oshirib belgilangan yoki ish vaqti hisobga olinmagan',
  '· обрезано по размеру': '· hajmi bo‘yicha qisqartirildi',
  '· ожидают': '· kutmoqda',
  '· просрочено': '· muddati o‘tgan',
  '· требуют решения': '· qaror talab qiladi',
  '«В цехе» — остаток по всем зонам хранения. Склад предприятия ведётся отдельно': '«Sexda» — barcha saqlash zonalari bo‘yicha qoldiq. Korxona ombori alohida yuritiladi',
  '«Использовать как есть» без обоснования не принимается: на него будут ссылаться при рекламации': '«Bor holicha ishlatish» asossiz qabul qilinmaydi: reklamatsiyada unga havola qilinadi',
  '«Нашла» — смена, обнаружившая брак. «Сделала» — та, из-за которой он возник': '«Topdi» — yaroqsizni aniqlagan smena. «Qildi» — u yuzaga kelishiga sabab bo‘lgan smena',
  '«Согласован» сразу замораживает содержимое и разузловывает маршрут': '«Kelishilgan» mazmunni darhol muzlatadi va marshrutni yoyadi',
  '+ вложенный': '+ ichki',
  '+ материал': '+ material',
  '+ характеристика': '+ tavsif',
  '0 для штук, 3 для килограммов': 'donalar uchun 0, kilogrammlar uchun 3',
  '1 — высший': '1 — eng yuqori',
  '3 — обычный': '3 — oddiy',
  '4–8 цифр': '4–8 raqam',
  '5 — низший': '5 — eng past',
  'автоповтор выключен': 'avtotakror o‘chirilgan',
  'автоповтор остановлен': 'avtotakror to‘xtatilgan',
  'Активной может быть одна версия на изделие. Правка карты не затрагивает уже разузлованные заказы: их операции зафиксированы копией.': 'Har bir mahsulot uchun bitta versiya faol bo‘ladi. Xaritani tahrirlash marshruti yoyilgan buyurtmalarga tegmaydi: ularning operatsiyalari nusxa bilan qayd etilgan.',
  'Анализ': 'Tahlil',
  'Анализ образца по бирке. Результат становится уровнем партии': 'Namunani birka bo‘yicha tahlil qilish. Natija partiya darajasiga aylanadi',
  'Анализов пока нет. Отсканируйте бирку образца': 'Hozircha tahlillar yo‘q. Namuna birkasini skanerlang',
  'Андон': 'Andon',
  'Аннулировать протокол': 'Bayonnomani kuchdan qoldirish',
  'Аннулировать сертификат': 'Sertifikatni kuchdan qoldirish',
  'Без затвора — операции закрываются без контролёра': 'Darvozasiz — operatsiyalar nazoratchisiz yopiladi',
  'без ключа': 'kalitsiz',
  'без металла:': 'metallsiz:',
  'без норматива': 'normasiz',
  'Без нормы производительность в OEE посчитается по такту изделия, а если и его нет — не посчитается': 'Normasiz OEE unumdorligi mahsulot takti bo‘yicha hisoblanadi, u ham bo‘lmasa — hisoblanmaydi',
  'Без причины исправление нельзя будет объяснить': 'Sababsiz tuzatishni tushuntirib bo‘lmaydi',
  'Без табельного номера оператор не войдёт на терминале': 'Tabel raqamisiz operator terminalga kira olmaydi',
  'Без текста причину нельзя будет выбрать — для случаев, где сама причина ничего не объясняет': 'Matnsiz sababni tanlab bo‘lmaydi — sababning o‘zi hech nimani tushuntirmaydigan hollar uchun',
  'Без указанной причины': 'Sabab ko‘rsatilmagan',
  'без штрихкода': 'shtrix-kodsiz',
  'Бирка': 'Birka',
  'брак': 'yaroqsiz',
  'Брак / дефект': 'Yaroqsiz / nuqson',
  'Брак и дефекты': 'Yaroqsiz va nuqsonlar',
  'Брак по партиям происхождения': 'Kelib chiqish partiyalari bo‘yicha yaroqsiz',
  'Брака': 'Yaroqsiz',
  'Бункер заводится пустым и наполняется загрузками': 'Bunker bo‘sh holda ochiladi va yuklamalar bilan to‘ldiriladi',
  'Бункер пуст. Брак попадёт сюда сам, когда оператор отметит его у станка': 'Bunker bo‘sh. Operator dastgoh yonida belgilaganda yaroqsiz bu yerga o‘zi tushadi',
  'Бункеры': 'Bunkerlar',
  'Буферная зона': 'Bufer zonasi',
  'В документ попадёт всё, что о партии известно: уровень, химия из последнего протокола, происхождение по родословной. Ничего вводить не нужно': 'Hujjatga partiya haqida ma’lum bo‘lgan hamma narsa tushadi: daraja, oxirgi bayonnomadagi kimyo, kelib chiqish zanjiri. Hech nima kiritish shart emas',
  'В маршруте нет ни одной начальной операции — поток некуда подать. Снимите связи у той, с которой всё начинается': 'Marshrutda birorta boshlang‘ich operatsiya yo‘q — oqimni berishga joy yo‘q. Hammasi boshlanadigan operatsiyadan bog‘lanishlarni oling',
  'в норме': 'me’yorda',
  'В норме': 'Me’yorda',
  'В норму закладывается технологический отход: если из прутка выходит 5 деталей вместо 6, норма считается по факту, а не по чертежу': 'Normaga texnologik chiqindi kiritiladi: sterjendan 6 emas, 5 dona chiqsa, norma chizma bo‘yicha emas, amaldagi holat bo‘yicha hisoblanadi',
  'В обороте': 'Aylanmada',
  'в порядке': 'joyida',
  'В потери': 'Yo‘qotishlarga',
  'в работе': 'ishda',
  'в ТО': 'texnik xizmatda',
  'В печь тару отправляет плавильщик — отсканирует её на экране навески. Кнопки «в переплав» здесь нет намеренно: металл едет по факту, а не по нажатию': 'Idishni pechga erituvchi yuboradi — uni shixta ekranida skanerlaydi. «Qayta eritishga» tugmasi bu yerda ataylab yo‘q: metall tugma bosilgani uchun emas, amalda ketadi',
  'В тоннах': 'Tonnada',
  'В цехе материалов нет. Оформите поступление на участок — это момент, когда материал переехал из кладовой в цех': 'Sexda material yo‘q. Uchastkaga kirimni rasmiylashtiring — bu material omborxonadan sexga o‘tgan payt',
  'В чём меряется выпуск этой операции': 'Bu operatsiya mahsuloti nimada o‘lchanadi',
  'Введите фактический расход — систему к нему приведём сами': 'Amaldagi sarfni kiriting — tizimni unga o‘zimiz keltiramiz',
  'Вернуть как было': 'Avvalgi holiga qaytarish',
  'Вернуть поставщику': 'Yetkazib beruvchiga qaytarish',
  'Версия': 'Versiya',
  'Вес': 'Vazn',
  'Вес единицы задаётся в номенклатуре': 'Birlik vazni nomenklaturada beriladi',
  'вес единицы не задан': 'birlik vazni berilmagan',
  'Вес единицы, кг': 'Birlik vazni, kg',
  'Вес, кг': 'Vazn, kg',
  'Вести по партиям': 'Partiyalar bo‘yicha yuritish',
  'весь завод': 'butun zavod',
  'Весь завод': 'Butun zavod',
  'Вид операции — словарь техпроцесса заказчика. Его умолчания подставляются в маршрутную карту, где их можно переопределить.': 'Operatsiya turi — buyurtmachi texjarayonining lug‘ati. Uning standart qiymatlari marshrut xaritasiga qo‘yiladi va u yerda o‘zgartirilishi mumkin.',
  'Вид определяет только префикс кода. Он не ограничивает, что за биркой окажется': 'Turi faqat kod prefiksini belgilaydi. Birka ortida nima bo‘lishini u cheklamaydi',
  'Видит производство целиком, может всё, что планировщик и мастер': 'Ishlab chiqarishni butunlay ko‘radi, rejalashtiruvchi va smena boshlig‘i qila oladigan hamma narsani qila oladi',
  'Виды операций': 'Operatsiya turlari',
  'Виды планового обслуживания. Плановое ТО не входит в плановое время OEE': 'Rejali xizmat ko‘rsatish turlari. Rejali texnik xizmat OEE rejali vaqtiga kirmaydi',
  'Вложен в предприятие': 'Korxonaga joylashgan',
  'Вложен в цех. К нему привязываются виды операций': 'Sexga joylashgan. Unga operatsiya turlari bog‘lanadi',
  'Вместимость': 'Sig‘imi',
  'вне нормы': 'me’yordan tashqari',
  'Внеплановая': 'Rejadan tashqari',
  'Внеплановая работа': 'Rejadan tashqari ish',
  'внеплановый': 'rejadan tashqari',
  'Внёс': 'Kiritdi',
  'внесли вы — одобряет другой': 'siz kiritdingiz — boshqasi tasdiqlaydi',
  'Внести протокол': 'Bayonnoma kiritish',
  'Возобновить': 'Davom ettirish',
  'Впишите его на планшете при первом входе оператора': 'Operator birinchi marta kirganda uni planshetga yozing',
  'впритык': 'zo‘rg‘a yetadi',
  'Время': 'Vaqt',
  'Время работы': 'Ish vaqti',
  'Время работы станка не записано — OEE посчитан по нулевому знаменателю': 'Dastgohning ish vaqti yozilmagan — OEE nol maxrajga hisoblangan',
  'Время работы станка не записано — OEE посчитан по нулевому знаменателю и ничего не показывает': 'Dastgohning ish vaqti yozilmagan — OEE nol maxrajga hisoblangan va hech nimani ko‘rsatmaydi',
  'Все': 'Hammasi',
  'Все внесённые протоколы прошли решение контролёра. Пока протокол не одобрен, сертификат на партию не выписывается.': 'Kiritilgan barcha bayonnomalar nazoratchi qaroridan o‘tgan. Bayonnoma tasdiqlanmaguncha partiyaga sertifikat yozilmaydi.',
  'Все доступные': 'Barcha mavjudlari',
  'Все зоны хранения': 'Barcha saqlash zonalari',
  'Всё необходимое настроено': 'Kerakli hamma narsa sozlangan',
  'Всё предприятие': 'Butun korxona',
  'Все роли': 'Barcha rollar',
  'всё сохранено': 'hammasi saqlandi',
  'всего': 'jami',
  'вход маршрута': 'marshrut kirishi',
  'Входное сырьё': 'Kiruvchi xomashyo',
  'Выберите бункер, чтобы увидеть, что в нём': 'Ichida nima borligini ko‘rish uchun bunkerni tanlang',
  'Выберите вид операции': 'Operatsiya turini tanlang',
  'Выберите материал': 'Materialni tanlang',
  'Выберите регламент — или отметьте работу как внеплановую': 'Reglamentni tanlang — yoki ishni rejadan tashqari deb belgilang',
  'Выберите станок': 'Dastgohni tanlang',
  'Выберите участок или цех наверху — задание выдаётся на них, а не на весь цех сразу.': 'Yuqorida uchastka yoki sexni tanlang — topshiriq butun sexga emas, ularga beriladi.',
  'Выбираются мастером при переводе станка в аварию. Влияют на Парето потерь времени': 'Dastgohni avariyaga o‘tkazishda smena boshlig‘i tanlaydi. Vaqt yo‘qotishlari Paretosiga ta’sir qiladi',
  'Выбираются оператором при отметке окончательного брака. Без них брак нельзя зарегистрировать': 'Operator yakuniy yaroqsizni belgilaganda tanlaydi. Ularsiz yaroqsizni qayd etib bo‘lmaydi',
  'Выбираются оператором при приостановке операции и мастером при смене задания': 'Operatsiyani to‘xtatib turishda operator, topshiriqni almashtirishda smena boshlig‘i tanlaydi',
  'Выбираются при отметке исправимого дефекта': 'Tuzatsa bo‘ladigan nuqsonni belgilashda tanlanadi',
  'выбор': 'tanlov',
  'выбор не нужен': 'tanlov kerak emas',
  'Выгрузить наряды за месяц': 'Oy naryadlarini yuklab olish',
  'Выгрузка наполняет список кодов. Соответствия проставляет человек: совпадение «Катодная медь М00к» и «Медь М00к» очевидно вам и не очевидно программе, а неверное соответствие отправит расход не того материала.': 'Yuklash kodlar ro‘yxatini to‘ldiradi. Moslikni odam qo‘yadi: «Катодная медь М00к» va «Медь М00к» mos kelishi sizga ravshan, dasturga esa yo‘q, noto‘g‘ri moslik esa boshqa materialning sarfini yuboradi.',
  'Выдан': 'Berilgan',
  'Выдан с оговорками. См. примечание.': 'Izohlar bilan berilgan. Eslatmaga qarang.',
  'Выдана': 'Berilgan',
  'Выданные': 'Berilganlar',
  'Выдать бирки': 'Birkalarni berish',
  'Выдать всё равно можно — остановить отгрузку мы не вправе. Но пояснение станет частью документа и останется в нём навсегда': 'Baribir berish mumkin — jo‘natishni to‘xtatishga haqimiz yo‘q. Ammo izoh hujjatning bir qismiga aylanadi va unda abadiy qoladi',
  'Выдать сертификат с оговоркой': 'Izoh bilan sertifikat berish',
  'Выделено — нажмите Ctrl+C': 'Belgilandi — Ctrl+C bosing',
  'Выключен': 'O‘chirilgan',
  'Выключите для обеда и регламентных перерывов: такое время вычитается из планового, а не считается потерей': 'Tushlik va reglament tanaffuslari uchun o‘chiring: bunday vaqt yo‘qotish emas, rejali vaqtdan ayiriladi',
  'Выпуск': 'Mahsulot',
  'Выпуск без исполнителя': 'Bajaruvchisiz mahsulot',
  'Выпуск годного по дням': 'Kunlar bo‘yicha yaroqli mahsulot',
  'выпуск не подтверждён мастером': 'mahsulotni smena boshlig‘i tasdiqlamagan',
  'Выпуска за смену не зарегистрировано': 'Smena davomida mahsulot qayd etilmagan',
  'Выпустить': 'Chiqarish',
  'Выпущено годного': 'Yaroqli chiqarildi',
  'Выработка': 'Ishlab chiqarish',
  'Высший': 'Eng yuqori',
  'Выход с первого предъявления': 'Birinchi taqdimdan chiqish',
  'Вычитаются из планового времени в OEE': 'OEE rejali vaqtidan ayiriladi',
  'Выше': 'Yuqoriroq',
  'Где': 'Qayerda',
  'Где может стоять': 'Qayerda turishi mumkin',
  'Где отмечено «нужен контроль» в маршруте': 'Marshrutda «nazorat kerak» deb belgilangan joylarda',
  'Где стоит': 'Qayerda turibdi',
  'Годен': 'Yaroqli',
  'годен / не годен': 'yaroqli / yaroqsiz',
  'Годен / не годен': 'Yaroqli / yaroqsiz',
  'Годен до': 'Yaroqlilik muddati',
  'Годится к отгрузке': 'Jo‘natishga yaroqli',
  'годно': 'yaroqli',
  'Годных': 'Yaroqli',
  'Готовая единица': 'Tayyor birlik',
  'Готовность контура': 'Kontur tayyorligi',
  'готово': 'tayyor',
  'Границы интервала не меняются — только причина': 'Interval chegaralari o‘zgarmaydi — faqat sabab',
  'Группа': 'Guruh',
  'да-нет': 'ha-yo‘q',
  'Дата документа': 'Hujjat sanasi',
  'дата неполная': 'sana to‘liq emas',
  'Дата поступления': 'Kelib tushgan sana',
  'Движений пока нет': 'Hozircha harakatlar yo‘q',
  'Движения не удаляются — только сторнируются: за каждым стоит бумага, и исправление задним числом должно быть видно': 'Harakatlar o‘chirilmaydi — faqat storno qilinadi: har birining ortida qog‘oz turadi va orqaga qaytib tuzatish ko‘rinib turishi kerak',
  'Делайте это при утере устройства или подозрении на компрометацию.': 'Buni qurilma yo‘qolganda yoki oshkor bo‘lgan deb gumon qilinganda qiling.',
  'Денег в файле нет: расценки живут в зарплатной системе, а считать сумму в двух местах значит однажды получить два разных ответа': 'Faylda pul yo‘q: narxlar ish haqi tizimida turadi, summani ikki joyda hisoblash esa bir kuni ikki xil javob olish demakdir',
  'День календаря': 'Kalendar kuni',
  'Дерево оборудования': 'Uskunalar daraxti',
  'Дерево пусто. Начните с предприятия, затем добавьте цеха, участки и станки.': 'Daraxt bo‘sh. Korxonadan boshlang, so‘ng sexlar, uchastkalar va dastgohlarni qo‘shing.',
  'Дефект': 'Nuqson',
  'Длительность': 'Davomiyligi',
  'Для клеёв, красок, паст': 'Yelim, bo‘yoq va pastalar uchun',
  'Для табло и списков. На бирку не печатается — принтер чёрно-белый': 'Tablo va ro‘yxatlar uchun. Birkaga bosilmaydi — printer oq-qora',
  'Для чего бирки': 'Birkalar nima uchun',
  'дни': 'kun',
  'до переточки': 'qayta charxlashgacha',
  'Добавить день': 'Kun qo‘shish',
  'Добавить операцию': 'Operatsiya qo‘shish',
  'Добавить показатель': 'Ko‘rsatkich qo‘shish',
  'Добавить строку': 'Qator qo‘shish',
  'Добавить табло': 'Tablo qo‘shish',
  'Добавить терминал': 'Terminal qo‘shish',
  'Добавить узел': 'Tugun qo‘shish',
  'Договор': 'Shartnoma',
  'Документ': 'Hujjat',
  'Доли в процентах от всей навески. Окно допуска отдельно от целевой доли: попасть в долю точно невозможно, а требовать этого — значит приучить гасить предупреждение не глядя': 'Butun shixtadan foizdagi ulushlar. Dopusk oynasi maqsadli ulushdan alohida: ulushga aniq tushish mumkin emas, buni talab qilish esa ogohlantirishni qaramay o‘chirishga o‘rgatish demakdir',
  'Доля, %': 'Ulush, %',
  'допуск не задан': 'dopusk berilmagan',
  'Допустить': 'Ruxsat berish',
  'Доработать': 'Qayta ishlash',
  'Доставок': 'Yetkazishlar',
  'Другая партия': 'Boshqa partiya',
  'Другой образец': 'Boshqa namuna',
  'Его спрашивают при рекламации': 'Reklamatsiyada uni so‘rashadi',
  'Единица измерения': 'O‘lchov birligi',
  'Единица, по которой считается OEE': 'OEE hisoblanadigan birlik',
  'единицу': 'birlikni',
  'Единицы': 'Birliklar',
  'Единственный, кто вносит измерения. Решение по несоответствию принимает не он, а мастер': 'O‘lchovlarni kiritadigan yagona odam. Nomuvofiqlik bo‘yicha qarorni u emas, smena boshlig‘i qabul qiladi',
  'её брак нашли другие': 'uning yaroqsizini boshqalar topgan',
  'Если источник неизвестен, заведите партию «сборный лом» и укажите её: у неизвестности должно быть имя, иначе она растворится в общей куче': 'Manba noma’lum bo‘lsa, «yig‘ma chiqindi» partiyasini oching va uni ko‘rsating: noma’lumlikning nomi bo‘lishi kerak, aks holda u umumiy uyumda eriydi',
  'Если металл пришёл со стороны': 'Metall chetdan kelgan bo‘lsa',
  'Если раньше начала — смена ночная': 'Boshlanishidan oldin bo‘lsa — smena tungi',
  'Если токен утерян — перевыпустите его здесь же. Старый перестанет работать сразу.': 'Token yo‘qolsa — uni shu yerda qayta chiqaring. Eskisi darhol ishlamay qoladi.',
  'Есть препятствия. Выдача с оговорками требует пояснения — оно попадёт в документ': 'To‘siqlar bor. Izoh bilan berish tushuntirishni talab qiladi — u hujjatga tushadi',
  'ещё не выгружались': 'hali yuklanmagan',
  'Ждёт приёмки': 'Qabulni kutmoqda',
  'Ждут одобрения СТК': 'STK tasdig‘ini kutmoqda',
  'Жёлтым — то, что сделали не здесь. Его доля и отвечает на вопрос, возвращается ли брак кругом через переплав': 'Sariq bilan — bu yerda qilinmagani. Uning ulushi yaroqsiz qayta eritish orqali aylanib qaytadimi degan savolga javob beradi',
  'живые операции заказов этого участка, в порядке очереди': 'shu uchastka buyurtmalarining jonli operatsiyalari, navbat tartibida',
  'Журнал анализов': 'Tahlillar jurnali',
  'За раз не больше 500 — иначе рулон никто не пересчитает': 'Bir martada 500 tadan ko‘p emas — aks holda rulonni hech kim qayta sanamaydi',
  'Заведена': 'Ochilgan',
  'Завёл': 'Ochdi',
  'Завершены': 'Yakunlangan',
  'Завершить': 'Yakunlash',
  'Завершить работу': 'Ishni yakunlash',
  'Завести тару': 'Idish ochish',
  'Завести тару под лом': 'Chiqindi uchun idish ochish',
  'Заводит и согласовывает заказы, ведёт ссылки на документы продаж': 'Buyurtmalarni ochadi va kelishadi, sotuv hujjatlariga havolalarni yuritadi',
  'Загружаем': 'Yuklanmoqda',
  'Загрузки': 'Yuklamalar',
  'Загрузок': 'Yuklamalar',
  'Задайте ресурс хотя бы одним счётчиком — иначе инструмент никогда не потребует внимания': 'Resursni hech bo‘lmasa bitta hisoblagich bilan bering — aks holda asbob hech qachon e’tibor talab qilmaydi',
  'Задайте хотя бы одну границу: без допуска годным будет любое значение': 'Hech bo‘lmasa bitta chegara bering: dopusksiz har qanday qiymat yaroqli bo‘ladi',
  'Задание': 'Topshiriq',
  'Заказ · операция': 'Buyurtma · operatsiya',
  'Заказ в терминальном статусе, переходы недоступны': 'Buyurtma yakuniy holatda, o‘tishlar mavjud emas',
  'Заказ встанет, когда материал кончится — подвезите заранее.': 'Material tugaganda buyurtma to‘xtaydi — oldindan yetkazing.',
  'Заказ не назначен': 'Buyurtma tayinlanmagan',
  'Заказов на участке нет': 'Uchastkada buyurtmalar yo‘q',
  'Заказов нет': 'Buyurtmalar yo‘q',
  'Заказов пока нет.': 'Hozircha buyurtmalar yo‘q.',
  'Заказы участка': 'Uchastka buyurtmalari',
  'Заключение': 'Xulosa',
  'закончить': 'yakunlash',
  'Закрытие смены': 'Smenani yopish',
  'Закрыть с необъяснённым простоем': 'Tushuntirilmagan to‘xtash bilan yopish',
  'Закрыть смену': 'Smenani yopish',
  'Замечания к расчёту:': 'Hisob-kitobga izohlar:',
  'Заморозка снимется, данные снова можно будет править. Кто, когда и зачем переоткрыл — останется в списке правок навсегда.': 'Muzlatish olinadi, ma’lumotlarni yana tahrirlash mumkin bo‘ladi. Kim, qachon va nima uchun qayta ochgani tuzatishlar ro‘yxatida abadiy qoladi.',
  'Запасной норматив для OEE': 'OEE uchun zaxira norma',
  'Запасной норматив: применяется, только если нет ни нормы операции, ни факта прошлых смен, ни такта изделия': 'Zaxira norma: faqat operatsiya normasi ham, o‘tgan smenalar amali ham, mahsulot takti ham bo‘lmaganda qo‘llaniladi',
  'Записал': 'Yozdim',
  'Записал, закрыть': 'Yozdim, yopish',
  'Записано, но ещё не обработано или не отправлено': 'Yozilgan, lekin hali qayta ishlanmagan yoki yuborilmagan',
  'Записать правку': 'Tuzatishni yozish',
  'Записать разрешение': 'Ruxsatni yozish',
  'Записей': 'Yozuvlar',
  'Записей нет': 'Yozuvlar yo‘q',
  'Записи из очереди ушедшего оператора: количество уже в учёте, назовите человека': 'Ketgan operator navbatidagi yozuvlar: miqdor allaqachon hisobda, odamni ko‘rsating',
  'Записи не удаляются — только отключаются, чтобы не разрушить историю отчётов.': 'Yozuvlar o‘chirilmaydi — hisobotlar tarixini buzmaslik uchun faqat o‘chirib qo‘yiladi.',
  'Запись останется зачёркнутой: содержимое бункера — это факт, и дыра в нём объясняется хуже, чем вычеркнутая строка': 'Yozuv chizib tashlangan holda qoladi: bunker ichidagisi — bu amaldagi holat, undagi bo‘shliq chizilgan qatordan ko‘ra yomonroq tushuntiriladi',
  'Заполните только то, что нужно сменить.': 'Faqat almashtirish kerak bo‘lganini to‘ldiring.',
  'Запуск другого задания приостановит эту операцию — укажите причину': 'Boshqa topshiriqni ishga tushirish bu operatsiyani to‘xtatib turadi — sababni ko‘rsating',
  'Заявлен': 'Bildirilgan',
  'Знаков после запятой': 'Kasr xonalari',
  'Зон хранения нет. Заведите буферную зону в дереве оборудования — материал учитывается в них': 'Saqlash zonalari yo‘q. Uskunalar daraxtida bufer zonasini oching — material ularda hisobga olinadi',
  'и другие': 'va boshqalar',
  'и пересчитайте — либо закройте как есть, если причина неизвестна.': 'va qayta hisoblang — yoki sabab noma’lum bo‘lsa, bor holicha yoping.',
  'Идёт': 'Ketmoqda',
  'Идёт сейчас': 'Hozir ketmoqda',
  'из': 'dan',
  'Из выгрузки склада. Пусто — обмен по этой позиции не работает': 'Ombor yuklamasidan. Bo‘sh — bu pozitsiya bo‘yicha almashuv ishlamaydi',
  'Из заказа, если он указан': 'Buyurtmadan, agar u ko‘rsatilgan bo‘lsa',
  'из имеющихся': 'mavjudlaridan',
  'Из чего его делают': 'U nimadan qilinadi',
  'Из чего сделано': 'Nimadan qilingan',
  'Изделие карты не меняется': 'Xarita mahsuloti o‘zgarmaydi',
  'изделий': 'mahsulot',
  'Излишек — добавить в зону': 'Ortiqcha — zonaga qo‘shish',
  'Изменить': 'O‘zgartirish',
  'Измерено': 'O‘lchangan',
  'Измеряемая': 'O‘lchanadigan',
  'Изолировано': 'Ajratilgan',
  'Изолировано, шт': 'Ajratilgan, dona',
  'Израсходована': 'Sarflangan',
  'Им оператор входит на терминале вместе с PIN': 'Operator u bilan PIN qo‘shib terminalga kiradi',
  'Именно его спрашивают при рекламации': 'Reklamatsiyada aynan uni so‘rashadi',
  'Имя': 'Ism',
  'Имя, логин, табельный': 'Ism, login, tabel',
  'Инструмент закреплён за станками — список ограничен ими': 'Asbob dastgohlarga biriktirilgan — ro‘yxat ular bilan cheklangan',
  'Исключений нет — завод работает по режиму недели. Праздники стоит завести заранее: плановые даты считаются по этому календарю': 'Istisnolar yo‘q — zavod hafta tartibi bo‘yicha ishlaydi. Bayramlarni oldindan kiritgan ma’qul: rejali sanalar shu kalendar bo‘yicha hisoblanadi',
  'Использовать как есть': 'Bor holicha ishlatish',
  'История статусов': 'Holatlar tarixi',
  'Итоги пересчитаны': 'Yakunlar qayta hisoblandi',
  'Итого': 'Jami',
  'Их номер': 'Ularning raqami',
  'каждая': 'har',
  'каждая деталь': 'har bir detal',
  'Каждая деталь': 'Har bir detal',
  'каждая N-я': 'har N-chi',
  'Каждая N-я': 'Har N-chi',
  'Каждое сообщение записывается до обработки — и то, что мы отправили, и то, что нам прислали. Через месяц это единственное, чем можно ответить на «а этот приход дошёл?».': 'Har bir xabar qayta ishlashdan oldin yoziladi — biz yuborganimiz ham, bizga yuborilgani ham. Bir oydan keyin «bu kirim yetib bordimi?» degan savolga faqat shu bilan javob berish mumkin.',
  'Как в системе': 'Tizimdagidek',
  'как у изделия': 'mahsulotdagidek',
  'Какие дни завод работает вообще. Праздники и переносы — ниже': 'Zavod umuman qaysi kunlari ishlaydi. Bayramlar va ko‘chirishlar — quyida',
  'Какой это лом': 'Bu qanday chiqindi',
  'Календарь двигает плановые даты заказов. Остановки отдельных станков сюда не заводятся — они живут в обслуживании и знают, кто их делает': 'Kalendar buyurtmalarning rejali sanalarini suradi. Alohida dastgohlarning to‘xtashi bu yerga kiritilmaydi — ular texnik xizmatda turadi va kim qilayotganini biladi',
  'Календарь читают через год: «нерабочий день» без причины оставляет только вопросы': 'Kalendarni bir yildan keyin o‘qishadi: sababsiz «ishlamaydigan kun» faqat savol qoldiradi',
  'Категория': 'Toifa',
  'кг': 'kg',
  'Кем произведена': 'Kim ishlab chiqargan',
  'Клиент отказался, изменение спецификации…': 'Mijoz rad etdi, spetsifikatsiya o‘zgardi…',
  'Смотреть можно всё, что доступно вашей роли. Изменения делаются с планшета или компьютера — на ходу с телефона легко нажать не ту кнопку.': 'Rolingizga ochiq hamma narsani ko‘rish mumkin. O‘zgartirishlar planshet yoki kompyuterdan qilinadi — yurib ketayotib telefonda noto‘g‘ri tugmani bosib yuborish oson.',
  'Код в WMS': 'WMS dagi kod',
  'Ключ события': 'Hodisa kaliti',
  'Код карты': 'Xarita kodi',
  'Код показателя': 'Ko‘rsatkich kodi',
  'Код родительской бирки': 'Ota birka kodi',
  'Код с бирки': 'Birkadagi kod',
  'Код с бирки образца': 'Namuna birkasidagi kod',
  'Код с бирки партии': 'Partiya birkasidagi kod',
  'Код читается с опечатками в регистре и пробелах. Последняя цифра — контрольная: она не даст открыть чужую партию из-за одной ошибки': 'Kod harf katta-kichikligi va bo‘shliqlardagi xatolar bilan ham o‘qiladi. Oxirgi raqam — nazorat raqami: u bitta xato tufayli begona partiyani ochishga yo‘l qo‘ymaydi',
  'Количество не создаёт, а подтверждает — передаёт дальше свой вход': 'Miqdorni yaratmaydi, tasdiqlaydi — o‘z kirishini keyinga uzatadi',
  'Комментарий обязателен': 'Izoh majburiy',
  'Комплектующие': 'Butlovchilar',
  'Компонент': 'Komponent',
  'Контроль': 'Nazorat',
  'Контроль качества': 'Sifat nazorati',
  'Контрольная операция': 'Nazorat operatsiyasi',
  'Контрольная операция: выпуск на ней не регистрируется, дальше по маршруту уходит то же количество, что пришло на вход': 'Nazorat operatsiyasi: unda mahsulot qayd etilmaydi, marshrut bo‘ylab kirishga kelgan miqdorning o‘zi ketadi',
  'Копировать': 'Nusxalash',
  'Корень дерева. Обычно один': 'Daraxt ildizi. Odatda bitta',
  'Коротко, как в журнале': 'Qisqacha, jurnaldagidek',
  'Корректировка': 'Tuzatish',
  'Корректировка по пересчёту': 'Qayta sanash bo‘yicha tuzatish',
  'Кто сделал брак': 'Yaroqsizni kim qilgan',
  'Куда вернуть станок': 'Dastgohni qayerga qaytarish',
  'Лаборатория': 'Laboratoriya',
  'линейный маршрут': 'chiziqli marshrut',
  'Лить такой лом в плавку значит вернуть в металл ту же беду, из-за которой он и стал ломом. Смотрите источники ниже': 'Bunday chiqindini eritishga quyish — uni chiqindiga aylantirgan balo metallga qaytarish demakdir. Quyidagi manbalarga qarang',
  'Логин': 'Login',
  'Лом': 'Chiqindi',
  'любое': 'har qanday',
  'Любое происхождение': 'Har qanday kelib chiqish',
  'Любое состояние': 'Har qanday holat',
  'Любой вид': 'Har qanday tur',
  'любые': 'har qanday',
  'М.П.': 'M.O‘.',
  'Маршрут не разузлован — это происходит при согласовании заказа': 'Marshrut yoyilmagan — bu buyurtma kelishilganda bo‘ladi',
  'Маршрут пуст. Добавьте хотя бы одну операцию — по ним заказ разузловывается.': 'Marshrut bo‘sh. Hech bo‘lmasa bitta operatsiya qo‘shing — buyurtma ular bo‘yicha yoyiladi.',
  'Маршрутные карты': 'Marshrut xaritalari',
  'Маршрутных карт нет.': 'Marshrut xaritalari yo‘q.',
  'Маршруты': 'Marshrutlar',
  'масса ед.': 'birlik massasi',
  'Материал испорчен и в производство не пойдёт. Из остатка уходит безвозвратно': 'Material buzilgan va ishlab chiqarishga ketmaydi. Qoldiqdan qaytarib bo‘lmaydigan tarzda chiqadi',
  'Материал остаётся в цехе, но меняет зону хранения': 'Material sexda qoladi, lekin saqlash zonasini almashtiradi',
  'Материал списан, но его поступление не оформлено. Проведите подвоз или разберитесь с расходом.': 'Material hisobdan chiqarilgan, lekin kirimi rasmiylashtirilmagan. Yetkazishni o‘tkazing yoki sarf bilan aniqlik kiriting.',
  'Материалы в цехе': 'Sexdagi materiallar',
  'Материалы ведутся отдельно от номенклатуры. Полуфабрикат заводится в обоих справочниках, поле «Изделие» связывает записи явно.': 'Materiallar nomenklaturadan alohida yuritiladi. Yarim tayyor mahsulot ikkala ma’lumotnomaga ham kiritiladi, «Mahsulot» maydoni yozuvlarni ochiq bog‘laydi.',
  'Меньше — лучше. Разрывы допустимы: 1, 2, 5 — чтобы потом вставить уровень между ними без перенумерации': 'Kichikroq — yaxshiroq. Uzilishlar mumkin: 1, 2, 5 — keyin ular orasiga qayta raqamlamasdan daraja qo‘shish uchun',
  'мера': 'o‘lchov',
  'Место': 'Joy',
  'Месяц': 'Oy',
  'Минимальный остаток': 'Eng kam qoldiq',
  'Минимум': 'Eng kami',
  'мм': 'mm',
  'Момент, когда материал переехал из кладовой в цех. Одна запись на подвоз, а не на смену': 'Material omborxonadan sexga o‘tgan payt. Bitta yozuv — bitta yetkazishga, smenaga emas',
  'н/д': 'm/y',
  'На доработку': 'Qayta ishlashga',
  'На единицу': 'Birlikka',
  'На каждом переделе': 'Har bir bosqichda',
  'На операциях': 'Operatsiyalarda',
  'На переточке': 'Qayta charxlashda',
  'на переточку': 'qayta charxlashga',
  'На связи': 'Aloqada',
  'На эту партию сертификатов нет. Передать можно, но при рекламации доказывать будет нечем': 'Bu partiyaga sertifikat yo‘q. Uzatish mumkin, lekin reklamatsiyada isbotlashga hech nima bo‘lmaydi',
  'На эту партию уже выдавались': 'Bu partiyaga allaqachon berilgan',
  'На эту смену задание не выдано. Оператор увидит всю очередь участка — это не поломка, но что делать в первую очередь, ему никто не сказал.': 'Bu smenaga topshiriq berilmagan. Operator uchastkaning butun navbatini ko‘radi — bu nosozlik emas, lekin avval nima qilishni unga hech kim aytmagan.',
  'Название в этой карте': 'Bu xaritadagi nomi',
  'Назначить': 'Tayinlash',
  'Назовите день: календарь читают через год, и «нерабочий день» без причины оставляет только вопросы': 'Kunga nom bering: kalendarni bir yildan keyin o‘qishadi va sababsiz «ishlamaydigan kun» faqat savol qoldiradi',
  'Найти': 'Topish',
  'Накладная': 'Yuk xati',
  'Накопитель. OEE по нему не считается': 'To‘plagich. Bo‘yicha OEE hisoblanmaydi',
  'накопленная доля': 'jamlangan ulush',
  'Напечатайте бирку в разделе «Партии» и повесьте на бункер. Пока бирки нет, тара есть в системе и нет в цехе': 'Birkani «Partiyalar» bo‘limida chop eting va bunkerga osing. Birka yo‘q ekan, idish tizimda bor, sexda esa yo‘q',
  'Напишите причину: инструмент стоит денег, и вопрос «почему» зададут': 'Sababni yozing: asbob pul turadi va «nega» degan savol beriladi',
  'Наработка': 'Ishlab berish',
  'Наработка в строке — снимок на момент события, а не сумма за всю жизнь: отсчёт идёт от последней переточки': 'Qatordagi ishlab berish — hodisa paytidagi holat, butun umr bo‘yicha yig‘indi emas: hisob oxirgi qayta charxlashdan boradi',
  'Наработка запишется снимком': 'Ishlab berish holat sifatida yoziladi',
  'Наработка запишется снимком — от неё пойдёт отсчёт до следующего срока': 'Ishlab berish holat sifatida yoziladi — keyingi muddatgacha hisob shundan boradi',
  'Наработка пересчитается сама: она считается по фактам, а не хранится числом': 'Ishlab berish o‘zi qayta hisoblanadi: u son bo‘lib saqlanmaydi, amaldagi holat bo‘yicha hisoblanadi',
  'Наработка считается по выпуску станка за время, пока инструмент на нём стоял, и отсчитывается от последней переточки. Отдельного счётчика нет намеренно: он разошёлся бы с отчётами на первом же сторно': 'Ishlab berish asbob dastgohda turgan vaqtdagi mahsulot bo‘yicha hisoblanadi va oxirgi qayta charxlashdan boshlanadi. Alohida hisoblagich ataylab yo‘q: u birinchi stornodayoq hisobotlardan ajralib ketardi',
  'Наработка считается по журналу состояний — только время, когда станок работал. Отдельного счётчика нет намеренно: он разошёлся бы с журналом на первой же правке задним числом': 'Ishlab berish holatlar jurnali bo‘yicha hisoblanadi — faqat dastgoh ishlagan vaqt. Alohida hisoblagich ataylab yo‘q: u orqaga qaytib qilingan birinchi tuzatishdayoq jurnaldan ajralib ketardi',
  'Настроить': 'Sozlash',
  'Настройка контура: справочники, дерево, терминалы, пользователи': 'Konturni sozlash: ma’lumotnomalar, daraxt, terminallar, foydalanuvchilar',
  'Настройки': 'Sozlamalar',
  'Настройки предприятия': 'Korxona sozlamalari',
  'Начали': 'Boshladik',
  'Начало': 'Boshlanishi',
  'Начало и конец совпадают': 'Boshlanishi va oxiri bir xil',
  'Начальник ОТК': 'STK boshlig‘i',
  'Начать': 'Boshlash',
  'Начать работу': 'Ishni boshlash',
  'Нашла': 'Topdi',
  'нашла чужого больше, чем сделала своего': 'o‘zi qilganidan ko‘ra begonasini ko‘proq topgan',
  'не более': 'ko‘pi bilan',
  'Не более, %': 'Ko‘pi bilan, %',
  'не выдано': 'berilmagan',
  'Не выполнены: за это время обстановка изменилась. Решайте по факту': 'Bajarilmagan: bu vaqt ichida vaziyat o‘zgardi. Amaldagi holatga qarab hal qiling',
  'не выполнялось': 'bajarilmagan',
  'Не годен': 'Yaroqsiz',
  'не доехало:': 'yetib bormadi:',
  'Не дошедшие приходы никто не повторит сам — нажмите «Повторить» или включите автоповтор в настройках': 'Yetib bormagan kirimlarni hech kim o‘zi takrorlamaydi — «Takrorlash»ni bosing yoki sozlamalarda avtotakrorni yoqing',
  'Не дошло': 'Yetib bormadi',
  'не закреплён за устройством': 'qurilmaga biriktirilmagan',
  'не короче 8 символов': '8 belgidan qisqa emas',
  'не менее': 'kami bilan',
  'Не менее, %': 'Kami bilan, %',
  'не мерено': 'o‘lchanmagan',
  'не обязательно': 'majburiy emas',
  'Не отменять': 'Bekor qilinmasin',
  'не привязана': 'bog‘lanmagan',
  'не привязано': 'bog‘lanmagan',
  'не присвоен': 'berilmagan',
  'не сопоставлено': 'moslashtirilmagan',
  'не сохранено:': 'saqlanmadi:',
  'не точится': 'charxlanmaydi',
  'не указан': 'ko‘rsatilmagan',
  'Не указана': 'Ko‘rsatilmagan',
  'не успевает': 'ulgurmayapti',
  'Неделя': 'Hafta',
  'Недостача — списать из зоны': 'Kamomad — zonadan hisobdan chiqarish',
  'Незавершённые действия с рабочих мест': 'Ish joylaridagi tugallanmagan amallar',
  'Незакрытых операций на участке нет': 'Uchastkada yopilmagan operatsiyalar yo‘q',
  'Незакрытых сообщений нет — всё, что отправляли и принимали за сутки, доехало.': 'Yopilmagan xabarlar yo‘q — sutka davomida yuborilgan va qabul qilinganlarning hammasi yetib bordi.',
  'необязательная': 'majburiy emas',
  'Нерабочий день': 'Ishlamaydigan kun',
  'Несоответствие': 'Nomuvofiqlik',
  'нет — вне планового времени': 'yo‘q — rejali vaqtdan tashqarida',
  'нет входа': 'kirish yo‘q',
  'Нет готовых заданий для этого участка. Задание появится, когда предыдущая операция передаст количество.': 'Bu uchastka uchun tayyor topshiriqlar yo‘q. Oldingi operatsiya miqdorni uzatganda topshiriq paydo bo‘ladi.',
  'нет данных': 'ma’lumot yo‘q',
  'Нет данных для расчёта за период': 'Davr uchun hisob-kitob ma’lumotlari yo‘q',
  'Нет данных за период': 'Davr uchun ma’lumot yo‘q',
  'Нет доступного оборудования': 'Mavjud uskuna yo‘q',
  'Нет доступных вариантов': 'Mavjud variantlar yo‘q',
  'Нет подходящих родителей — сначала создайте узел уровнем выше': 'Mos ota tugunlar yo‘q — avval bir daraja yuqorida tugun yarating',
  'нет такта': 'takt yo‘q',
  'Ни один показатель не заполнен': 'Birorta ko‘rsatkich to‘ldirilmagan',
  'ни разу не выполнялось': 'hech qachon bajarilmagan',
  'Ниже': 'Pastroq',
  'Ниже него подсвечивается нехватка. Пусто — не следим': 'Undan pastda kamomad yoritiladi. Bo‘sh — kuzatilmaydi',
  'Нижняя граница больше верхней': 'Pastki chegara yuqorisidan katta',
  'Ничего не выбрано — весь день целиком. Смены отмечают, когда стоит не завод, а одна смена: например, ночная перед праздником': 'Hech nima tanlanmagan — butun kun. Smenalar zavod emas, bitta smena to‘xtaganda belgilanadi: masalan, bayram oldidan tungi smena',
  'Ничего не выбрано — где угодно. Так и оставьте, если ограничения в цехе нет: выдуманный запрет наладчик обойдёт мимо системы': 'Hech nima tanlanmagan — istalgan joyda. Sexda cheklov bo‘lmasa, shundayligicha qoldiring: o‘ylab topilgan taqiqni sozlovchi tizimni chetlab o‘tadi',
  'Ничего не ждёт приёмки. Здесь появляются операции, выпуск которых нельзя передать дальше без разрешения контролёра.': 'Hech nima qabulni kutmayapti. Bu yerda mahsulotini nazoratchi ruxsatisiz keyinga uzatib bo‘lmaydigan operatsiyalar paydo bo‘ladi.',
  'Новая единица измерения': 'Yangi o‘lchov birligi',
  'Новая карта': 'Yangi xarita',
  'Новая партия поставщика': 'Yetkazib beruvchining yangi partiyasi',
  'новая по накладной': 'yuk xati bo‘yicha yangi',
  'Новая причина': 'Yangi sabab',
  'Новая смена': 'Yangi smena',
  'Новое изделие': 'Yangi mahsulot',
  'Новое табло': 'Yangi tablo',
  'Новый вид операции': 'Yangi operatsiya turi',
  'Новый заказ': 'Yangi buyurtma',
  'Новый материал': 'Yangi material',
  'Новый пароль': 'Yangi parol',
  'Новый уровень качества': 'Yangi sifat darajasi',
  'Новый PIN': 'Yangi PIN',
  'Ноль — не перетачивается: отработал и списан': 'Nol — charxlanmaydi: ishlab bo‘ldi va hisobdan chiqarildi',
  'Номенклатура': 'Nomenklatura',
  'Номер и название обязательны': 'Raqam va nom majburiy',
  'Номер или партия': 'Raqam yoki partiya',
  'номер накладной': 'yuk xati raqami',
  'Номер операции': 'Operatsiya raqami',
  'Номер поставщика': 'Yetkazib beruvchi raqami',
  'Номер, партия, документ, контрагент': 'Raqam, partiya, hujjat, kontragent',
  'Номера операций повторяются — они должны быть уникальны': 'Operatsiya raqamlari takrorlanmoqda — ular takrorlanmas bo‘lishi kerak',
  'Номера уже закреплены за вашим предприятием. Если лист не напечатается, бирки не пропадут — их можно найти в списке и напечатать снова.': 'Raqamlar allaqachon korxonangizga biriktirilgan. Varaq chop etilmasa, birkalar yo‘qolmaydi — ularni ro‘yxatdan topib, qayta chop etish mumkin.',
  'Номера через 10 — чтобы можно было вставить операцию между': 'Raqamlar 10 tadan — orasiga operatsiya qo‘shish mumkin bo‘lishi uchun',
  'норма': 'norma',
  'Норма на годное': 'Yaroqliga norma',
  'Норма по умолчанию, сек/ед': 'Standart norma, sek/birl.',
  'Норма, с/ед': 'Norma, s/birl.',
  'Нормативы': 'Normalar',
  'Ночная': 'Tungi',
  'ночная смена — переходит через полночь': 'tungi smena — yarim tundan o‘tadi',
  'Нужен для сводки в тоннах. Пусто — тонны не показываются': 'Tonnadagi hisobot uchun kerak. Bo‘sh — tonnalar ko‘rsatilmaydi',
  'нужен контроль': 'nazorat kerak',
  'Нужно для прослеживаемости. Выключите для расходников: партия шлифкруга никому не нужна': 'Kuzatuvchanlik uchun kerak. Sarf materiallari uchun o‘chiring: charxlash doirasining partiyasi hech kimga kerak emas',
  'Область видимости': 'Ko‘rish doirasi',
  'Обмен': 'Almashuv',
  'Обмен с внешними системами': 'Tashqi tizimlar bilan almashuv',
  'Обмен со складом': 'Ombor bilan almashuv',
  'Обмена ещё не было. Записи появятся, когда склад пришлёт первое событие или мы отправим первый приход.': 'Hali almashuv bo‘lmagan. Ombor birinchi hodisani yuborganda yoki biz birinchi kirimni yuborganda yozuvlar paydo bo‘ladi.',
  'обмена не было': 'almashuv bo‘lmagan',
  'Обнаружил': 'Aniqladi',
  'Обозначение по чертежу': 'Chizma bo‘yicha belgilanishi',
  'Обоснование': 'Asos',
  'Обработано по операциям': 'Operatsiyalar bo‘yicha ishlangan',
  'Образец отобран': 'Namuna olindi',
  'Обслуживаемые станки': 'Xizmat ko‘rsatiladigan dastgohlar',
  'Обслуживание': 'Texnik xizmat',
  'Обслуживание и оснастка: регламенты ТО, установка и переточка инструмента. Смену не закрывает и выпуск не сдаёт': 'Texnik xizmat va asboblar: TX reglamentlari, asbobni o‘rnatish va qayta charxlash. Smenani yopmaydi va mahsulot topshirmaydi',
  'обязателен': 'majburiy',
  'Один справочник с категориями: интерфейс подставляет нужный срез оператору и мастеру': 'Toifali bitta ma’lumotnoma: interfeys operator va smena boshlig‘iga kerakli qismini qo‘yadi',
  'Окончание': 'Tugashi',
  'Окончательный брак': 'Yakuniy yaroqsiz',
  'Оператор': 'Operator',
  'Оператор забыл PIN — это решается здесь за минуту': 'Operator PIN ni unutdi — bu shu yerda bir daqiqada hal bo‘ladi',
  'Операций с планом контроля нет. Характеристики задаются в маршрутной карте': 'Nazorat rejasi bor operatsiyalar yo‘q. Tavsiflar marshrut xaritasida beriladi',
  'Определяет, где причина предлагается': 'Sabab qayerda taklif qilinishini belgilaydi',
  'Определяет, чей это брак. «Свой передел» — смены, которая его сделала; «предыдущий» или «химия плавки» — той, что сварила металл. Без этого брак записывается на того, кто его нашёл, и внимательная смена выглядит худшей': 'Bu kimning yaroqsizi ekanini belgilaydi. «O‘z bosqichi» — uni qilgan smenaniki; «oldingi» yoki «eritma kimyosi» — metallni eritgan smenaniki. Busiz yaroqsiz uni topgan odamga yoziladi va e’tiborli smena eng yomoni bo‘lib ko‘rinadi',
  'оснастка': 'asbob',
  'Оснастка': 'Asbob',
  'Оснастка не заведена. Пока инструмент безымянный, «брак по оснастке» означает «виноват станок», то есть никто: завтра там будет другая фильера, а изношенная уедет на соседний стан и продолжит': 'Asboblar kiritilmagan. Asbob nomsiz ekan, «asbob sababli yaroqsiz» degani «dastgoh aybdor», ya’ni hech kim: ertaga u yerda boshqa filyera turadi, eskirgani esa qo‘shni stanga ketib davom etadi',
  'Остановка завода': 'Zavodning to‘xtashi',
  'Остаток': 'Qoldiq',
  'Ответ': 'Javob',
  'Отгружается': 'Jo‘natilmoqda',
  'Отказ по смыслу — повторять бесполезно, нужен человек': 'Mazmunan rad etish — takrorlash befoyda, odam kerak',
  'Отказано': 'Rad etildi',
  'отказов:': 'rad etishlar:',
  'Отклонение навесок от рецепта': 'Shixtalarning retseptdan chetlanishi',
  'Отклонение размера': 'O‘lcham chetlanishi',
  'Отклонения от режима недели. Сильнее его в обе стороны': 'Hafta tartibidan chetlanishlar. Ikkala tomonga ham undan kuchliroq',
  'Отклонить': 'Rad etish',
  'Отклонить протокол': 'Bayonnomani rad etish',
  'Отключение и перевыпуск токена обрывают работающий экран сразу, не дожидаясь истечения выданного ключа.': 'Tokenni o‘chirish va qayta chiqarish ishlab turgan ekranni berilgan kalit muddati tugashini kutmasdan darhol uzadi.',
  'Открытые вызовы с рабочих мест': 'Ish joylaridan ochiq chaqiruvlar',
  'Открытые несоответствия': 'Ochiq nomuvofiqliklar',
  'Открытых тар нет. Заведите бункер — без него брак у станка складывать некуда': 'Ochiq idishlar yo‘q. Bunker oching — usiz dastgoh yonidagi yaroqsizni qo‘yishga joy yo‘q',
  'Открыть': 'Ochish',
  'Открыть на проверку': 'Tekshirish uchun ochish',
  'Откуда лом': 'Chiqindi qayerdan',
  'Откуда причина': 'Sabab qayerdan',
  'Откуда пришёл металл и куда он ушёл — по коду с бирки': 'Metall qayerdan kelgan va qayerga ketgan — birkadagi kod bo‘yicha',
  'Откуда, по источникам': 'Qayerdan, manbalar bo‘yicha',
  'Отменены': 'Bekor qilingan',
  'Отменить': 'Bekor qilish',
  'Отмечено «нужен контроль», но мерить нечего — у контролёра операция не появится': '«Nazorat kerak» belgilangan, lekin o‘lchashga hech nima yo‘q — nazoratchida operatsiya paydo bo‘lmaydi',
  'Отправил': 'Yubordi',
  'Отправитель не дал идентификатора: повторную доставку от новой не отличить': 'Yuboruvchi identifikator bermagan: takroriy yetkazishni yangisidan ajratib bo‘lmaydi',
  'Отправить на переточку': 'Qayta charxlashga yuborish',
  'Отправить снова': 'Qayta yuborish',
  'Отправить этот приход складу ещё раз': 'Bu kirimni omborga yana bir marta yuborish',
  'Отрицательное «сверх нормы» — не экономия. Обычно это значит, что часть расхода не оформлена, и остаток в системе больше, чем в цехе': 'Manfiy «normadan ortiq» — tejamkorlik emas. Odatda bu sarfning bir qismi rasmiylashtirilmaganini va tizimdagi qoldiq sexdagidan ko‘p ekanini bildiradi',
  'Отсканируйте бирку того, откуда лом': 'Chiqindi qayerdan kelganining birkasini skanerlang',
  'Отчёт за эту смену уже был открыт': 'Bu smena hisoboti allaqachon ochilgan edi',
  'очередь': 'navbat',
  'очередь пуста': 'navbat bo‘sh',
  'Очередь пуста: ничего не просрочено, ресурс нигде не на исходе, незакрытых работ нет. Так и должно выглядеть спокойное утро': 'Navbat bo‘sh: hech nimaning muddati o‘tmagan, hech qayerda resurs tugamayapti, yopilmagan ishlar yo‘q. Tinch ertalab shunday ko‘rinishi kerak',
  'ошибка в накладной': 'yuk xatidagi xato',
  'Пароли и PIN не хранятся в открытом виде и не показываются — их можно только задать заново.': 'Parollar va PIN ochiq holda saqlanmaydi va ko‘rsatilmaydi — ularni faqat qaytadan berish mumkin.',
  'Пароль': 'Parol',
  'Пароль и PIN': 'Parol va PIN',
  'Пароль не короче 8 символов': 'Parol 8 belgidan qisqa emas',
  'Партии': 'Partiyalar',
  'Партии и бирки': 'Partiyalar va birkalar',
  'Партии поставщика': 'Yetkazib beruvchi partiyalari',
  'Партий нет. Выдайте бирки — они печатаются пустыми и ждут металла': 'Partiyalar yo‘q. Birkalarni bering — ular bo‘sh chop etiladi va metallni kutadi',
  'Партия не может быть собственным родителем': 'Partiya o‘zining otasi bo‘la olmaydi',
  'Партия передела': 'Bosqich partiyasi',
  'Паспорт': 'Pasport',
  'Пауза': 'Pauza',
  'первая деталь': 'birinchi detal',
  'Первая деталь': 'Birinchi detal',
  'Передана на склад': 'Omborga topshirilgan',
  'Передано с оговорками:': 'Izohlar bilan topshirilgan:',
  'Передать': 'Topshirish',
  'Передать на склад': 'Omborga topshirish',
  'Переделов назад': 'Necha bosqich orqada',
  'Перемещение': 'Ko‘chirish',
  'Перемещение между зонами': 'Zonalar orasida ko‘chirish',
  'Переналадки': 'Qayta sozlashlar',
  'Перенести с прошлой смены': 'O‘tgan smenadan ko‘chirish',
  'Переоткрыть': 'Qayta ochish',
  'Переоткрыть смену': 'Smenani qayta ochish',
  'Перепечатать выданные': 'Berilganlarni qayta chop etish',
  'Перерасход материалов': 'Materiallarning ortiqcha sarfi',
  'Перерывы': 'Tanaffuslar',
  'Перерывы, мин': 'Tanaffuslar, daq.',
  'Пересчёт разошёлся с учётом. Излишек добавляется в зону, недостача списывается': 'Qayta sanash hisob bilan mos kelmadi. Ortiqchasi zonaga qo‘shiladi, kamomad hisobdan chiqariladi',
  'Пересчитать': 'Qayta hisoblash',
  'Переточен': 'Qayta charxlangan',
  'Переточки': 'Qayta charxlashlar',
  'Печать': 'Chop etish',
  'Печать бирки': 'Birkani chop etish',
  'Печать листа': 'Varaqni chop etish',
  'Печать предпросмотра': 'Ko‘rib chiqishni chop etish',
  'План контроля': 'Nazorat rejasi',
  'План контроля пуст': 'Nazorat rejasi bo‘sh',
  'Плановое': 'Rejali',
  'Плановое время за смену, мин': 'Smena uchun rejali vaqt, daq.',
  'Плановое время, мин': 'Rejali vaqt, daq.',
  'Плановые даты заказов пересчитаются сразу: они не хранятся, а считаются': 'Buyurtmalarning rejali sanalari darhol qayta hisoblanadi: ular saqlanmaydi, hisoblanadi',
  'По активной карте заказ разузловывается в операции при согласовании': 'Faol xarita bo‘yicha buyurtma kelishilganda operatsiyalarga yoyiladi',
  'По нормам': 'Normalar bo‘yicha',
  'по норме': 'norma bo‘yicha',
  'По норме': 'Norma bo‘yicha',
  'По происхождению': 'Kelib chiqishi bo‘yicha',
  'По регламенту': 'Reglament bo‘yicha',
  'По терминалу': 'Terminal bo‘yicha',
  'По умолчанию': 'Standart',
  'По умолчанию всё, что за биркой. Партия могла ужаться в переделах — на склад уходит то, что реально положили': 'Standart holda birka ortidagi hamma narsa. Partiya bosqichlarda kamaygan bo‘lishi mumkin — omborga haqiqatda qo‘yilgani ketadi',
  'По умолчанию работают все семь дней: у непрерывного производства это так и есть, а поставленная по умолчанию пятидневка сдвинула бы все плановые даты, ничего об этом не сказав': 'Standart holda yetti kun ham ishlanadi: uzluksiz ishlab chiqarishda shunday, standart qilib qo‘yilgan besh kunlik esa barcha rejali sanalarni bu haqda hech nima demasdan surib yuborardi',
  'По этому отбору записей нет.': 'Bu tanlov bo‘yicha yozuvlar yo‘q.',
  'повтор вот-вот': 'takror hozir bo‘ladi',
  'Повторите пароль': 'Parolni takrorlang',
  'Повторите пароль — значения не совпадают': 'Parolni takrorlang — qiymatlar mos kelmayapti',
  'Повторите PIN': 'PIN ni takrorlang',
  'Повторите PIN — значения не совпадают': 'PIN ni takrorlang — qiymatlar mos kelmayapti',
  'Повторить': 'Takrorlash',
  'Под этот отбор никто не подошёл.': 'Bu tanlovga hech kim mos kelmadi.',
  'Под этот отбор ничего не подошло.': 'Bu tanlovga hech nima mos kelmadi.',
  'подготовка': 'tayyorgarlik',
  'Подготовка на партию': 'Partiyaga tayyorgarlik',
  'Подготовка по умолчанию, с': 'Standart tayyorgarlik, s',
  'Подготовка, с': 'Tayyorgarlik, s',
  'Поднесите сканер или введите код с бирки': 'Skanerni yaqinlashtiring yoki birkadagi kodni kiriting',
  'Подробности': 'Tafsilotlar',
  'Подставить': 'Qo‘yish',
  'Подставляется в новый шаг маршрута': 'Marshrutning yangi qadamiga qo‘yiladi',
  'Подтвердить': 'Tasdiqlash',
  'Подтвердить отмену': 'Bekor qilishni tasdiqlash',
  'Подтянуть со склада': 'Ombordan tortib olish',
  'позиций': 'pozitsiya',
  'Поиск': 'Qidiruv',
  'Пойдёт': 'Bo‘ladi',
  'Пока замер вне допуска не разобран, сдать годное по операции нельзя. Брак и дефект сдаются': 'Dopuskdan tashqari o‘lchov ko‘rib chiqilmaguncha operatsiya bo‘yicha yaroqlini topshirib bo‘lmaydi. Yaroqsiz va nuqson topshiriladi',
  'Пока эти записи не разобраны, смену закрыть нельзя: в замороженном документе подтвердить исполнителя будет уже негде, и работа пропадёт из табеля.': 'Bu yozuvlar ko‘rib chiqilmaguncha smenani yopib bo‘lmaydi: muzlatilgan hujjatda bajaruvchini tasdiqlashga joy qolmaydi va ish tabeldan yo‘qoladi.',
  'Показатели и границы подставятся из состава материала. Если состав не заведён, добавьте показатели руками — администратор потом занесёт их в справочник': 'Ko‘rsatkichlar va chegaralar material tarkibidan qo‘yiladi. Tarkib kiritilmagan bo‘lsa, ko‘rsatkichlarni qo‘lda qo‘shing — administrator keyin ularni ma’lumotnomaga kiritadi',
  'Показать все': 'Hammasini ko‘rsatish',
  'Показать все заказы': 'Barcha buyurtmalarni ko‘rsatish',
  'Показать всех': 'Hammani ko‘rsatish',
  'Показывает': 'Ko‘rsatadi',
  'показывается один раз — перепишите сейчас': 'bir marta ko‘rsatiladi — hozir ko‘chirib yozing',
  'показывать отключённых': 'o‘chirilganlarni ko‘rsatish',
  'Полноэкранное табло для цехового экрана': 'Sex ekrani uchun to‘liq ekranli tablo',
  'Положить': 'Solish',
  'Положить лом': 'Chiqindi solish',
  'Пользователей пока нет': 'Hozircha foydalanuvchilar yo‘q',
  'Пользователи': 'Foydalanuvchilar',
  'Пометка к пачке': 'Dastaga belgi',
  'Пометка складу': 'Omborga belgi',
  'пометки': 'belgilar',
  'Понятно': 'Tushunarli',
  'После': 'Keyin',
  'После закрытия данные смены заморожены: сторнировать отчёты и править причины будет нельзя.': 'Yopilgandan keyin smena ma’lumotlari muzlatiladi: hisobotlarni storno qilish va sabablarni tahrirlash mumkin bo‘lmaydi.',
  'После передачи партия выходит из MES. Дальше её ведёт склад — и код бирки должен переехать на складскую этикетку': 'Topshirilgandan keyin partiya MES dan chiqadi. Uni keyin ombor yuritadi — birka kodi esa ombor yorlig‘iga ko‘chishi kerak',
  'Последние движения': 'Oxirgi harakatlar',
  'последняя в партии': 'partiyadagi oxirgisi',
  'Последняя в партии': 'Partiyadagi oxirgisi',
  'Посмотреть рабочее место оператора': 'Operator ish joyini ko‘rish',
  'поставить': 'o‘rnatish',
  'Поставить': 'O‘rnatish',
  'Поступила': 'Kelib tushdi',
  'Поступление': 'Kirim',
  'Поступление на участок': 'Uchastkaga kirim',
  'Потери времени': 'Vaqt yo‘qotishlari',
  'Потерь за период не зарегистрировано': 'Davr uchun yo‘qotishlar qayd etilmagan',
  'Почему не допущен': 'Nega ruxsat berilmagan',
  'Почему эта работа не засчитывается?': 'Nega bu ish hisobga olinmayapti?',
  'Пояснение': 'Tushuntirish',
  'ППР, инвентаризация, отключение энергии': 'RPT, inventarizatsiya, energiyani o‘chirish',
  'Пр.': 'Ust.',
  'правится': 'tahrirlanmoqda',
  'правка': 'tuzatish',
  'Правка не затронет уже разузлованные заказы — их операции зафиксированы': 'Tuzatish marshruti yoyilgan buyurtmalarga tegmaydi — ularning operatsiyalari qayd etilgan',
  'Правка не переписывает списанное по норме — она встаёт рядом. Иначе исчезнет сама величина расхождения, ради которой правка и нужна.': 'Tuzatish norma bo‘yicha hisobdan chiqarilganini qayta yozmaydi — u yoniga qo‘yiladi. Aks holda tuzatish nima uchun kerak bo‘lgan farqning o‘zi yo‘qoladi.',
  'Правки': 'Tuzatishlar',
  'Правки и подтверждение': 'Tuzatishlar va tasdiqlash',
  'Праздник или объявленный выходной': 'Bayram yoki e’lon qilingan dam olish kuni',
  'Праздники, переносы и остановки': 'Bayramlar, ko‘chirishlar va to‘xtashlar',
  'Предприятие → цех → участок → станок. Буферные зоны — узлы того же дерева': 'Korxona → sex → uchastka → dastgoh. Bufer zonalari — shu daraxtning tugunlari',
  'ПРЕДПРОСМОТР': 'KO‘RIB CHIQISH',
  'Предыдущая версия выключена: активной может быть одна карта на изделие': 'Oldingi versiya o‘chirildi: har bir mahsulot uchun bitta xarita faol bo‘ladi',
  'Прежние анализы этой партии': 'Bu partiyaning oldingi tahlillari',
  'Привязать': 'Bog‘lash',
  'Привязать металл': 'Metallni bog‘lash',
  'Привязать металл к бирке': 'Metallni birkaga bog‘lash',
  'Привязывается только к оборудованию — не к цеху и не к буферной зоне': 'Faqat uskunaga bog‘lanadi — sexga ham, bufer zonasiga ham emas',
  'Приёмка передела': 'Bosqichni qabul qilish',
  'Применено на той стороне': 'U tomonda qo‘llanildi',
  'Примечание к закрытию': 'Yopishga eslatma',
  'Примечание.': 'Eslatma.',
  'Принял': 'Qabul qildi',
  'Принять': 'Qabul qilish',
  'Принять решение': 'Qaror qabul qilish',
  'Приход на склад': 'Omborga kirim',
  'Причина — часть выпуска не принята': 'Sabab — mahsulotning bir qismi qabul qilinmadi',
  'Причина отмены': 'Bekor qilish sababi',
  'Причина переоткрытия — она останется в документе': 'Qayta ochish sababi — u hujjatda qoladi',
  'Причина приостановки текущего задания': 'Joriy topshiriqni to‘xtatib turish sababi',
  'Причины': 'Sabablar',
  'Проверка итогов, правки, затем заморозка документа': 'Yakunlarni tekshirish, tuzatishlar, so‘ng hujjatni muzlatish',
  'Провести': 'O‘tkazish',
  'Продукция соответствует заявленному уровню качества и допущена к отгрузке.': 'Mahsulot e’lon qilingan sifat darajasiga mos keladi va jo‘natishga ruxsat etilgan.',
  'Производственная дата': 'Ishlab chiqarish sanasi',
  'Произвольная, для отбора': 'Ixtiyoriy, tanlash uchun',
  'Произвольная, для фильтров': 'Ixtiyoriy, filtrlar uchun',
  'Прослеживаемость': 'Kuzatuvchanlik',
  'просрочено': 'muddati o‘tgan',
  'Простои': 'To‘xtashlar',
  'Простой': 'To‘xtash',
  'Простой без причины': 'Sababsiz to‘xtash',
  'Протокол лаборатории не приложен.': 'Laboratoriya bayonnomasi ilova qilinmagan.',
  'Протокол останется видимым: разбор через полгода не должен упереться в дыру, которую никто не объяснит. Уровень с партии не снимается': 'Bayonnoma ko‘rinib turadi: yarim yildan keyingi tahlil hech kim tushuntirmaydigan bo‘shliqqa tiralmasligi kerak. Partiyadan daraja olinmaydi',
  'протоколов': 'bayonnoma',
  'Пункты без кнопки пока заводятся через API — экраны для них добавляются по шагам.': 'Tugmasiz bandlar hozircha API orqali kiritiladi — ular uchun ekranlar bosqichma-bosqich qo‘shiladi.',
  'пусто — бессрочно': 'bo‘sh — muddatsiz',
  'Пусто — доступ ко всему предприятию. Выбранный узел открывает и всё, что под ним': 'Bo‘sh — butun korxonaga kirish. Tanlangan tugun ostidagi hamma narsani ham ochadi',
  'Пусто — операцию можно назначить на любой участок': 'Bo‘sh — operatsiyani istalgan uchastkaga tayinlash mumkin',
  'Пусто — причина доступна везде. «Износ шлифкруга» осмысленна не на всех станках': 'Bo‘sh — sabab hamma joyda mavjud. «Charxlash doirasining yeyilishi» hamma dastgohda ham ma’noli emas',
  'Пусто — считается как длительность минус перерывы': 'Bo‘sh — davomiylik minus tanaffuslar sifatida hisoblanadi',
  'Пусто или 1 — один оператор: вход следующего закрывает смену предыдущего. Больше — бригада: смены копятся, и каждый отмечается своим PIN. Число плановое, превышение не запрещается — забытая чужая смена не должна оставлять пришедшего без работы': 'Bo‘sh yoki 1 — bitta operator: keyingisining kirishi oldingisining smenasini yopadi. Ko‘proq — brigada: smenalar to‘planadi va har kim o‘z PIN i bilan belgilanadi. Son rejaviy, oshib ketish taqiqlanmaydi — unutilgan begona smena kelgan odamni ishsiz qoldirmasligi kerak',
  'Работаем там, где по режиму недели выходной': 'Hafta tartibi bo‘yicha dam olish bo‘lgan joyda ishlaymiz',
  'Работает': 'Ishlayapti',
  'Работает на терминале: старт операции, выпуск, вызов мастера. Нужны табельный номер и PIN': 'Terminalda ishlaydi: operatsiya boshlanishi, mahsulot, smena boshlig‘ini chaqirish. Tabel raqami va PIN kerak',
  'Работник': 'Xodim',
  'Рабочий день': 'Ish kuni',
  'развилка после': 'keyin ayri',
  'Разница': 'Farq',
  'Разобрано': 'Ko‘rib chiqilgan',
  'Разобрать': 'Ko‘rib chiqish',
  'Разрешённые участки': 'Ruxsat etilgan uchastkalar',
  'Расход': 'Sarf',
  'Расход материала': 'Material sarfi',
  'Расход материала на единицу': 'Birlikka material sarfi',
  'Расход со склада': 'Ombordan sarf',
  'Расходные материалы': 'Sarf materiallari',
  'расчёт по очереди участков, без переналадок и выходных': 'uchastkalar navbati bo‘yicha hisob, qayta sozlash va dam olishlarsiz',
  'Расчётная доля': 'Hisoblangan ulush',
  'Расчётная доля — оценка, а не измерение: бригадный выпуск поделён поровну между теми, кто был у станка в момент сдачи. Начислять по ней нельзя без решения о том, что бригадный выпуск делится именно так': 'Hisoblangan ulush — o‘lchov emas, baho: brigada mahsuloti topshirish paytida dastgoh yonida bo‘lganlar orasida teng bo‘lingan. Brigada mahsuloti aynan shunday bo‘linadi degan qaror bo‘lmasa, unga qarab hisoblab bo‘lmaydi',
  'Регламент': 'Reglament',
  'Регламентов нет. Заведите их в настройке — без регламента обслуживание не наступит никогда, и система о нём не напомнит': 'Reglamentlar yo‘q. Ularni sozlamalarda kiriting — reglamentsiz texnik xizmat hech qachon kelmaydi va tizim u haqda eslatmaydi',
  'Режим недели': 'Hafta tartibi',
  'ресурс выработан, переточек не осталось': 'resurs tugadi, qayta charxlash qolmadi',
  'ресурс выработан, пора на переточку': 'resurs tugadi, qayta charxlash vaqti',
  'Ресурс до переточки': 'Qayta charxlashgacha resurs',
  'Рецепт': 'Retsept',
  'Решение': 'Qaror',
  'решение — не с телефона': 'qaror — telefondan emas',
  'Решение примет мастер: документ нужен, чтобы на вопрос «кто пропустил эту партию и на каком основании» был ответ.': 'Qarorni smena boshlig‘i qabul qiladi: hujjat «bu partiyani kim va qanday asosda o‘tkazgan» degan savolga javob bo‘lishi uchun kerak.',
  'Решение принимает мастер или руководство': 'Qarorni smena boshlig‘i yoki rahbariyat qabul qiladi',
  'Решить': 'Hal qilish',
  'Родитель': 'Ota tugun',
  'Родословная': 'Kelib chiqish zanjiri',
  'Роль': 'Rol',
  'Роль определяет доступные экраны, область видимости — какую часть предприятия видно': 'Rol mavjud ekranlarni belgilaydi, ko‘rish doirasi — korxonaning qaysi qismi ko‘rinishini',
  'С этой минуты весь выпуск станка идёт инструменту в наработку — и брак по оснастке будет назван его номером': 'Shu daqiqadan boshlab dastgohning butun mahsuloti asbobning ishlab berishiga yoziladi — asbob sababli yaroqsiz esa uning raqami bilan ataladi',
  'с/ед': 's/birl.',
  'Сверх нормы': 'Normadan ortiq',
  'Светлая тема': 'Yorug‘ mavzu',
  'Свободен': 'Bo‘sh',
  'Связей нет: партия ни из чего не выведена и никуда пока не пошла': 'Bog‘lanishlar yo‘q: partiya hech nimadan chiqarilmagan va hozircha hech qayerga ketmagan',
  'Сдал лично': 'Shaxsan topshirdi',
  'сдано лично · расчётная доля': 'shaxsan topshirilgan · hisoblangan ulush',
  'Сдача годного закрыта': 'Yaroqlini topshirish yopilgan',
  'Сделала': 'Qildi',
  'Сделано': 'Bajarildi',
  'Сделать активной': 'Faol qilish',
  'Сейчас выполняется': 'Hozir bajarilmoqda',
  'сек': 'sek',
  'сек/ед': 'sek/birl.',
  'Сертификат качества': 'Sifat sertifikati',
  'Сертификатов пока нет. Отсканируйте бирку партии': 'Hozircha sertifikatlar yo‘q. Partiya birkasini skanerlang',
  'Сертификаты': 'Sertifikatlar',
  'Сеть или таймаут — повторить можно': 'Tarmoq yoki taymaut — takrorlash mumkin',
  'Система ничего не выполнила намеренно: «завершить», нажатое три часа назад, закрыло бы операцию, над которой уже работает сменщик. Нужное действие сделайте сами на экране участка, затем отметьте здесь.': 'Tizim ataylab hech nima qilmadi: uch soat oldin bosilgan «yakunlash» ustida almashuvchi allaqachon ishlayotgan operatsiyani yopib qo‘yardi. Kerakli amalni uchastka ekranida o‘zingiz bajaring, so‘ng shu yerda belgilang.',
  'Сканируйте бирки того, из чего это вышло. Можно несколько — плавка, пруток, оснастка. Пустой список означает, что металл пришёл со стороны': 'Bu nimadan chiqqan bo‘lsa, o‘shaning birkalarini skanerlang. Bir nechta bo‘lishi mumkin — eritma, sterjen, asbob. Bo‘sh ro‘yxat metall chetdan kelganini bildiradi',
  'склад': 'ombor',
  'Сколько бирок печатать?': 'Nechta birka chop etilsin?',
  'Сколько брака дала каждая партия ниже по переделам. Считается по родословной': 'Har bir partiya keyingi bosqichlarda qancha yaroqsiz bergan. Kelib chiqish zanjiri bo‘yicha hisoblanadi',
  'Сколько выходных единиц получается из входных': 'Kiruvchi birliklardan qancha chiquvchi birlik olinadi',
  'Сколько деталей отложено до решения': 'Qaror chiqquncha nechta detal ajratib qo‘yilgan',
  'Сколько передаётся': 'Qancha topshirilmoqda',
  'Сколько переточек выдерживает': 'Nechta qayta charxlashga chidaydi',
  'сколько успеете': 'qanchaga ulgursangiz',
  'Скопировано': 'Nusxalandi',
  'скоро': 'yaqinda',
  'Скрыть': 'Yashirish',
  'Следующий': 'Keyingisi',
  'Случаев': 'Holatlar',
  'Смена закрыта. Данные заморожены': 'Smena yopildi. Ma’lumotlar muzlatildi',
  'Смена переоткрыта, данные снова можно править. Запись осталась в документе': 'Smena qayta ochildi, ma’lumotlarni yana tahrirlash mumkin. Yozuv hujjatda qoldi',
  'Смена родителя переносит узел вместе со всем поддеревом': 'Ota tugunni almashtirish tugunni butun ost daraxti bilan ko‘chiradi',
  'Сменное задание': 'Smena topshirig‘i',
  'Сменные отчёты': 'Smena hisobotlari',
  'Смены задают производственную дату. Ночная смена целиком относится к суткам своего начала.': 'Smenalar ishlab chiqarish sanasini belgilaydi. Tungi smena to‘liq o‘z boshlangan sutkasiga tegishli.',
  'Сначала заведите номенклатуру и виды операций — из них собирается карта.': 'Avval nomenklatura va operatsiya turlarini kiriting — xarita ulardan yig‘iladi.',
  'Сначала заведите станки в дереве оборудования — терминал привязывается к ним.': 'Avval uskunalar daraxtida dastgohlarni kiriting — terminal ularga bog‘lanadi.',
  'Сначала устраните причину отказа — иначе ответ будет тот же': 'Avval rad etish sababini bartaraf eting — aks holda javob o‘sha bo‘ladi',
  'Снимите для уровней, которые заказчику не уходят и годятся только в переплав': 'Buyurtmachiga ketmaydigan va faqat qayta eritishga yaroqli darajalar uchun olib tashlang',
  'Снят': 'Yechilgan',
  'Снять': 'Yechish',
  'Снять со станка': 'Dastgohdan yechish',
  'Собираются из партии, анализа и родословной. Уходят заказчику': 'Partiya, tahlil va kelib chiqish zanjiridan yig‘iladi. Buyurtmachiga ketadi',
  'Собрано из сроков обслуживания и ресурса оснастки. Сначала то, что уже идёт: станок в этот момент стоит, и закрыть работу важнее, чем начать следующую': 'Texnik xizmat muddatlari va asbob resursidan yig‘ilgan. Avval ketayotgani: dastgoh shu payt to‘xtab turibdi va ishni yopish keyingisini boshlashdan muhimroq',
  'Собрать': 'Yig‘ish',
  'Собрать задание': 'Topshiriq yig‘ish',
  'Событий нет: инструмент заведён, но ни разу не ставился': 'Hodisalar yo‘q: asbob kiritilgan, lekin hech qachon o‘rnatilmagan',
  'Согласовал': 'Kelishdi',
  'согласовано с заказчиком, письмо №…': 'buyurtmachi bilan kelishilgan, xat №…',
  'Согласованы': 'Kelishilgan',
  'Создайте первый — кнопка «Новый заказ».': 'Birinchisini yarating — «Yangi buyurtma» tugmasi.',
  'Создал': 'Yaratdi',
  'Создать': 'Yaratish',
  'Создать в статусе': 'Qaysi statusda yaratilsin',
  'Сорт': 'Nav',
  'Состав и допуски. Границы можно оставить пустыми — показатель тогда записывается для истории, но вердикт по нему не выносится': 'Tarkib va dopusklar. Chegaralarni bo‘sh qoldirish mumkin — u holda ko‘rsatkich tarix uchun yoziladi, lekin bo‘yicha hukm chiqarilmaydi',
  'Спецификация': 'Spetsifikatsiya',
  'Списан': 'Hisobdan chiqarilgan',
  'Списание': 'Hisobdan chiqarish',
  'Списание необратимо. Запись останется: на неё ссылается разбор брака': 'Hisobdan chiqarish qaytarilmaydi. Yozuv qoladi: yaroqsiz tahlili unga havola qiladi',
  'Списание порчи': 'Buzilganini hisobdan chiqarish',
  'Списано': 'Hisobdan chiqarilgan',
  'Списано руками': 'Qo‘lda hisobdan chiqarilgan',
  'Списать': 'Hisobdan chiqarish',
  'списывать': 'hisobdan chiqarish',
  'Справочник материалов пуст — заведите материалы в закладке «Материалы»': 'Materiallar ma’lumotnomasi bo‘sh — materiallarni «Materiallar» bo‘limida kiriting',
  'Справочник материалов пуст — заведите материалы в настройках': 'Materiallar ma’lumotnomasi bo‘sh — materiallarni sozlamalarda kiriting',
  'Справочники склада': 'Ombor ma’lumotnomalari',
  'Сразу на переточку': 'Darhol qayta charxlashga',
  'срок не задан': 'muddat berilmagan',
  'Сроки': 'Muddatlar',
  'станки': 'dastgohlar',
  'Станок один — оператору он подставится автоматически, выбирать не придётся': 'Dastgoh bitta — operatorga u o‘zi qo‘yiladi, tanlash shart bo‘lmaydi',
  'Станок по умолчанию': 'Standart dastgoh',
  'Станок свободен': 'Dastgoh bo‘sh',
  'Станок уйдёт в ТО автоматически: незакрытое «работает» на стоящем станке портит доступность в OEE': 'Dastgoh o‘zi texnik xizmatga o‘tadi: to‘xtab turgan dastgohdagi yopilmagan «ishlayapti» OEE mavjudligini buzadi',
  'Старый токен перестанет действовать немедленно, привязка к устройству снимется, а работающий экран погаснет и попросит настройку.': 'Eski token darhol ishlamay qoladi, qurilmaga bog‘lanish olinadi, ishlab turgan ekran esa o‘chib, sozlashni so‘raydi.',
  'Старый токен перестанет работать немедленно. Терминал, на котором он прописан, выйдет из строя до ввода нового — оператор не сможет войти.': 'Eski token darhol ishlamay qoladi. U yozilgan terminal yangisi kiritilgunga qadar ishlamaydi — operator kira olmaydi.',
  'Сторнировать движение': 'Harakatni storno qilish',
  'Сторнировать загрузку': 'Yuklamani storno qilish',
  'сторно': 'storno',
  'строка': 'qator',
  'Строка расхода заполняется целиком: материал и норма больше нуля': 'Sarf qatori to‘liq to‘ldiriladi: material va noldan katta norma',
  'Структура предприятия и справочники': 'Korxona tuzilmasi va ma’lumotnomalar',
  'Сутки': 'Sutka',
  'Счёт / заказ': 'Hisob / buyurtma',
  'Считать потерей': 'Yo‘qotish deb hisoblash',
  'Сырьё и заготовки': 'Xomashyo va zagotovkalar',
  'Табель': 'Tabel',
  'Табельный номер': 'Tabel raqami',
  'Табло': 'Tablo',
  'Табло не заведено. Экран в цехе можно повесить и без него — мастер открывает андон со своего компьютера, — но тогда его придётся открывать заново каждую смену.': 'Tablo kiritilmagan. Sexdagi ekranni usiz ham osish mumkin — smena boshlig‘i andonni o‘z kompyuteridan ochadi, — lekin u holda uni har smenada qaytadan ochish kerak bo‘ladi.',
  'такт изделия из справочника': 'ma’lumotnomadagi mahsulot takti',
  'Такт изделия используется для OEE, когда у заказа нет маршрута или норма не задана в операции.': 'Mahsulot takti buyurtmada marshrut bo‘lmaganda yoki operatsiyada norma berilmaganda OEE uchun ishlatiladi.',
  'Такт нужен для производительности в OEE, когда норма не задана в операции. Плановое время — если станок работает не всю смену.': 'Takt operatsiyada norma berilmaganda OEE unumdorligi uchun kerak. Rejali vaqt — dastgoh butun smena ishlamasa.',
  'Такт станка — последняя ступень расчёта норматива: берётся, только если нет ни нормы операции, ни факта прошлых смен, ни такта изделия': 'Dastgoh takti — normani hisoblashning oxirgi bosqichi: faqat operatsiya normasi ham, o‘tgan smenalar amali ham, mahsulot takti ham bo‘lmaganda olinadi',
  'Такт, с': 'Takt, s',
  'Тара заведена:': 'Idish ochildi:',
  'Тара опорожнена': 'Idish bo‘shatildi',
  'Тара пуста': 'Idish bo‘sh',
  'Телефон — только просмотр.': 'Telefon — faqat ko‘rish.',
  'Тело сообщения': 'Xabar tanasi',
  'Тёмная тема': 'Qorong‘i mavzu',
  'Терминалов в цехе меньше, чем станков: их ставят там, где нужен учёт. Один терминал может обслуживать несколько станков участка.': 'Sexda terminallar dastgohlardan kam: ular hisob kerak bo‘lgan joyga qo‘yiladi. Bitta terminal uchastkaning bir necha dastgohiga xizmat qilishi mumkin.',
  'Терминалов нет': 'Terminallar yo‘q',
  'Терминалы': 'Terminallar',
  'Только входное сырьё: номер, сертификат и срок годности — свойства того, что пришло со стороны. Свои партии живут на экране «Партии», у них родословная и уровень качества. Номер уникален в пределах материала: у двух поставщиков он вполне может совпасть.': 'Faqat kiruvchi xomashyo: raqam, sertifikat va yaroqlilik muddati — chetdan kelganning xossalari. O‘z partiyalari «Partiyalar» ekranida turadi, ularda kelib chiqish zanjiri va sifat darajasi bor. Raqam material doirasida takrorlanmas: ikki yetkazib beruvchida u mos kelishi mumkin.',
  'Только для оборудования': 'Faqat uskuna uchun',
  'Только для полуфабрикатов, которые вы сами и производите': 'Faqat o‘zingiz ishlab chiqaradigan yarim tayyor mahsulotlar uchun',
  'тонну': 'tonnani',
  'Тот же материал, что и у металла: лом стали 45 остаётся сталью 45, и в плавку он пойдёт как она': 'Metall bilan bir xil material: 45-po‘lat chiqindisi 45-po‘lat bo‘lib qoladi va eritishga o‘sha sifatida ketadi',
  'Точность': 'Aniqlik',
  'Точность определяет, сколько знаков после запятой принимается в выпуске.': 'Aniqlik mahsulotda nechta kasr xonasi qabul qilinishini belgilaydi.',
  'Требовать комментарий': 'Izohni talab qilish',
  'Требует внимания до закрытия:': 'Yopishdan oldin e’tibor talab qiladi:',
  'Требуют решения': 'Qaror talab qiladi',
  'У пользователя нет табельного номера — PIN не заработает, пока он не задан': 'Foydalanuvchining tabel raqami yo‘q — u berilmaguncha PIN ishlamaydi',
  'У этого материала ещё нет партий — заведите новую по накладной': 'Bu materialda hali partiyalar yo‘q — yuk xati bo‘yicha yangisini oching',
  'У этого станка регламентов нет. Заведите в настройке или отметьте работу внеплановой': 'Bu dastgohda reglamentlar yo‘q. Sozlamalarda kiriting yoki ishni rejadan tashqari deb belgilang',
  'Убрать строку': 'Qatorni olib tashlash',
  'Удалить': 'O‘chirish',
  'Узел': 'Tugun',
  'Узлы не удаляются — только отключаются. Отключение блокируется, если есть вложенные объекты, активные терминалы или незакрытые заказы.': 'Tugunlar o‘chirilmaydi — faqat o‘chirib qo‘yiladi. Ichki obyektlar, faol terminallar yoki yopilmagan buyurtmalar bo‘lsa, o‘chirib qo‘yish bloklanadi.',
  'Укажите вес больше нуля': 'Noldan katta vaznni ko‘rsating',
  'Укажите дату': 'Sanani ko‘rsating',
  'Укажите количество больше нуля': 'Noldan katta miqdorni ko‘rsating',
  'Укажите обозначение по чертежу и название характеристики': 'Chizma bo‘yicha belgilanishni va tavsif nomini ko‘rsating',
  'Укажите шаг выборки: каждую какую деталь проверять': 'Tanlab olish qadamini ko‘rsating: har nechanchi detal tekshirilsin',
  'Укажите, какой это лом': 'Bu qanday chiqindi ekanini ko‘rsating',
  'Указывают на пропавшие коды склада:': 'Yo‘qolgan ombor kodlariga ishora qiladi:',
  'Указываются при отмене заказа': 'Buyurtma bekor qilinganda ko‘rsatiladi',
  'Унёс брак': 'Yaroqsiz olib ketdi',
  'Уровень брака': 'Yaroqsizlik darajasi',
  'Уровни качества': 'Sifat darajalari',
  'успевает': 'ulguryapti',
  'Успеем': 'Ulguramiz',
  'Установить на станок': 'Dastgohga o‘rnatish',
  'Установлен': 'O‘rnatilgan',
  'Устройство': 'Qurilma',
  'Устройство в цехе, с которого оператор отчитывается о выпуске': 'Sexdagi qurilma — operator undan mahsulot haqida hisobot beradi',
  'Утвердить': 'Tasdiqlash',
  'Утверждено': 'Tasdiqlangan',
  'Участки': 'Uchastkalar',
  'Участок или цех': 'Uchastka yoki sex',
  'Участок: назначение заданий, состояния станков, закрытие смены': 'Uchastka: topshiriq tayinlash, dastgoh holatlari, smenani yopish',
  'Учётные записи не удаляются — только отключаются: за ними стоят отчёты выпуска и история статусов.': 'Hisob yozuvlari o‘chirilmaydi — faqat o‘chirib qo‘yiladi: ular ortida mahsulot hisobotlari va holatlar tarixi turadi.',
  'Ушло на годное': 'Yaroqliga ketdi',
  'факт прошлых смен на этом станке': 'shu dastgohdagi o‘tgan smenalar amali',
  'факт прошлых смен на этом станке с этим изделием': 'shu dastgohda shu mahsulot bilan o‘tgan smenalar amali',
  'факт прошлых смен по этому переходу': 'shu o‘tish bo‘yicha o‘tgan smenalar amali',
  'Фильера': 'Filyera',
  'Химический состав': 'Kimyoviy tarkib',
  'Химия': 'Kimyo',
  'Хотя бы один день недели должен быть рабочим — иначе планировать некуда': 'Haftaning hech bo‘lmasa bir kuni ish kuni bo‘lishi kerak — aks holda rejalashtirishga joy yo‘q',
  'Хотя бы один. Если заданы оба — сработает тот, что наступит раньше': 'Hech bo‘lmasa bittasi. Ikkalasi ham berilsa — avval keladigani ishlaydi',
  'Цвет': 'Rang',
  'Целевые показатели': 'Maqsadli ko‘rsatkichlar',
  'Цель': 'Maqsad',
  'Цель за смену': 'Smena uchun maqsad',
  'цель не задана': 'maqsad berilmagan',
  'Цех': 'Sex',
  'Цехов и участков в дереве нет': 'Daraxtda sexlar va uchastkalar yo‘q',
  'Цеховые терминалы': 'Sex terminallari',
  'часов работы станка': 'dastgohning ish soatlari',
  'Часть дат за горизонтом расчёта — дальше он не считается, и подставлять туда число было бы выдумкой': 'Sanalarning bir qismi hisob ufqidan tashqarida — undan nariga hisoblanmaydi, u yerga son qo‘yish esa o‘ylab topish bo‘lardi',
  'Часть кода': 'Kodning bir qismi',
  'Часы': 'Soatlar',
  'Чей брак': 'Kimning yaroqsizi',
  'Человек в бригаде': 'Brigadadagi odam',
  'чем мерить': 'nima bilan o‘lchash',
  'через': 'keyin',
  'число': 'son',
  'Что': 'Nima',
  'Что в бункерах цеха и откуда оно там': 'Sex bunkerlarida nima bor va u qayerdan kelgan',
  'Что делать': 'Nima qilish kerak',
  'Что делают': 'Nima qilishadi',
  'Что за биркой': 'Birka ortida nima',
  'Что за лом': 'Qanday chiqindi',
  'Что за работа': 'Qanday ish',
  'Что именно и где': 'Aynan nima va qayerda',
  'Что исправлено или сверено': 'Nima tuzatildi yoki solishtirildi',
  'Что лежит на участках и хватит ли на смену. Склад предприятия ведётся отдельно': 'Uchastkalarda nima yotibdi va smenaga yetadimi. Korxona ombori alohida yuritiladi',
  'Что можно поставить': 'Nimani qo‘yish mumkin',
  'Что нажимали': 'Nima bosilgan',
  'Что обнаружено': 'Nima aniqlandi',
  'Что показывает': 'Nimani ko‘rsatadi',
  'Что попадёт в документ': 'Hujjatga nima tushadi',
  'Что проверяет лаборатория': 'Laboratoriya nimani tekshiradi',
  'Что произошло, что предпринято': 'Nima bo‘ldi, nima qilindi',
  'Что сделано': 'Nima qilindi',
  'Что ушло сверх нормы на годном, что унёс брак, что списали руками': 'Yaroqliga normadan ortiq nima ketdi, yaroqsiz nimani olib ketdi, qo‘lda nima hisobdan chiqarildi',
  'Что это создало у нас': 'Bu bizda nima yaratdi',
  'Чья работа': 'Kimning ishi',
  'Шкала одна на оба конца цикла: вперёд это приёмка, назад — сорт лома. Порядок важнее названий: по нему сравниваются партии.': 'Shkala siklning ikkala uchiga bitta: oldinga bu qabul, orqaga — chiqindi navi. Tartib nomlardan muhimroq: partiyalar shu bo‘yicha solishtiriladi.',
  'Штука': 'Dona',
  'Экономит оператору нажатие в начале смены. Без умолчания выбор обязателен': 'Operatorga smena boshida bitta bosishni tejaydi. Standart qiymatsiz tanlov majburiy',
  'Экран в проходе. Показывает состояние оборудования участка и не умеет ничего больше': 'O‘tish joyidagi ekran. Uchastka uskunalarining holatini ko‘rsatadi va boshqa hech nima qila olmaydi',
  'это вы': 'bu siz',
  'Это же действие переносит табло на другой экран.': 'Xuddi shu amal tabloni boshqa ekranga ko‘chiradi.',
  'Это и есть ответ на вопрос, почему дальше пойдёт брак. Всё, что выйдет из этой партии, будет видно по её родословной': 'Nega keyin yaroqsiz ketishi savoliga javob shu. Bu partiyadan chiqadigan hamma narsa uning kelib chiqish zanjirida ko‘rinadi',
  'Этот номер уже на руках у заказчика. Аннулированный сертификат остаётся видимым и печатается с отметкой — иначе при рекламации предъявят бумагу, которой в системе нет': 'Bu raqam allaqachon buyurtmachi qo‘lida. Kuchdan qoldirilgan sertifikat ko‘rinib turadi va belgi bilan chop etiladi — aks holda reklamatsiyada tizimda yo‘q qog‘ozni ko‘rsatishadi',
  'OEE по оборудованию': 'Uskunalar bo‘yicha OEE',
  'PIN — от 4 до 8 цифр': 'PIN — 4 dan 8 gacha raqam',
  'PIN для терминала': 'Terminal uchun PIN',
  'PIN работает только вместе с табельным номером': 'PIN faqat tabel raqami bilan birga ishlaydi',
  'Ничего не найдено': 'Hech nima topilmadi',
  'Например: закрыто до того, как сменщик отметил выпуск': 'Masalan: almashuvchi mahsulotni belgilashidan oldin yopilgan',
  'Например: медь ниже нормы, повторный отбор': 'Masalan: mis normadan past, qayta namuna olish',
  'Например: ошибка в количестве': 'Masalan: miqdorda xato',
  'Например: перепутан бункер': 'Masalan: bunker adashtirilgan',
  'Например: перепутан образец': 'Masalan: namuna adashtirilgan',
  'Например: рулон для печи №2': 'Masalan: 2-pech uchun rulon',
  'Например: смена сверена с журналом': 'Masalan: smena jurnal bilan solishtirildi',
  'Например: у ТЦ-01, площадка А': 'Masalan: ТЦ-01 yonida, A maydonchasi',
  'Например: скол на рабочей кромке': 'Masalan: ishchi qirrada uchib ketish',
  'Например: стук в шпинделе': 'Masalan: shpindelda taqillash',
  'Табло механического цеха': 'Mexanika sexi tablosi',
  'Терминал токарного участка': 'Tokarlik uchastkasi terminali',
  'Новый год · ППР прокатного участка': 'Yangi yil · Prokat uchastkasi RPT',
  'Фильера Ø18 твердосплавная': 'Filyera Ø18 qattiq qotishmali',
  '{n} комп.': '{n} komp.',
  '{n} показ.': '{n} ko‘rs.',
  'Передано с оговорками: {list}': 'Izohlar bilan topshirildi: {list}',
  'развилка после {list}': '{list} dan keyin ayri',
  'входов {n}': 'kirishlar {n}',
  'концов {n}': 'oxirlar {n}',
  'Протокол по {batch} допущен': '{batch} bo‘yicha bayonnomaga ruxsat berildi',
  'Протокол по {batch} отклонён': '{batch} bo‘yicha bayonnoma rad etildi',
  'партии': 'partiya',
  '{res} до переточки': 'qayta charxlashgacha {res}',
  ', что раньше': ', qaysi biri avval bo‘lsa',
  '-я': '-chi',
  'каждая {n}-я': 'har {n}-chi',
  'через {n} дн': '{n} kundan keyin',
  'через {n} ч': '{n} soatdan keyin',
  'просрочено на {n} дн': '{n} kunga kechikkan',
  'просрочено на {n} ч': '{n} soatga kechikkan',
  '{n} дн': '{n} kun',
  '{n} ч': '{n} soat',
  '{n} шт': '{n} dona',
  'перебор {n} шт': '{n} dona ortiqcha',
  'перебор {n} ч': '{n} soat ortiqcha',
  'затвор: {n1}': 'darvoza: {n1}',
  'оп. {n1} · {n2}': 'op. {n1} · {n2}',
  '{n1} · оп. {n2} {n3}': '{n1} · op. {n2} {n3}',
  'Разобрано {n1} при предъявленных {n2}': 'Ko‘rib chiqilgan {n1}, taqdim etilgan {n2}',
  '· до {n1} — годно': '· {n1} gacha — yaroqli',
  'Комментарий{n1}': 'Izoh{n1}',
  'от {n1}': '{n1} dan',
  'АННУЛИРОВАН {n1} — {n2}': 'KUCHDAN QOLDIRILGAN {n1} — {n2}',
  'Протокол лаборатории от {n1}': '{n1} dagi laboratoriya bayonnomasi',
  'Выдал: {n1}': 'Berdi: {n1}',
  'Токен устройства для {n1}': '{n1} uchun qurilma tokeni',
  'привязано {n1}': 'bog‘langan {n1}',
  'чужих попыток: {n1}, последняя {n2} назад': 'begona urinishlar: {n1}, oxirgisi {n2} oldin',
  'Перевыпустить токен {n1}?': '{n1} tokeni qayta chiqarilsinmi?',
  'выгружено {n1}': 'yuklandi {n1}',
  '· без пары {n1}': '· juftsiz {n1}',
  'подтянуто {n1}': 'tortib olindi {n1}',
  '· пропало {n1}': '· yo‘qoldi {n1}',
  '· не разобрано {n1}': '· ko‘rib chiqilmagan {n1}',
  '· завершено {n1}': '· yakunlangan {n1}',
  ', {n1} мест{n2}': ', {n1} joy{n2}',
  'шт · {n1}': 'dona · {n1}',
  'Задание для {n1}': '{n1} uchun topshiriq',
  'пр. {n1}': 'ust. {n1}',
  'готово {n1} из {n2}': '{n2} dan {n1} tayyor',
  'срок {n1}': 'muddat {n1}',
  'цель {n1}{n2}': 'maqsad {n1}{n2}',
  'из {n1} {n2}': '{n1} {n2} dan',
  'брак {n1}': 'yaroqsiz {n1}',
  'из {n1} т': '{n1} t dan',
  'Ссылки на документ продаж нет — {n1}': 'Sotuv hujjatiga havola yo‘q — {n1}',
  'работы {n1} см': 'ish {n1} smena',
  '· упирается в {n1}': '· {n1} ga tiralgan',
  'План не посчитан: {n1}': 'Reja hisoblanmadi: {n1}',
  'из {n1} → {n2} {n3}': '{n1} dan → {n2} {n3}',
  'норма {n1} с/ед': 'norma {n1} s/birl.',
  'факт {n1}': 'amalda {n1}',
  'план {n1} → {n2}': 'reja {n1} → {n2}',
  '· ожидается {n1}': '· kutilmoqda {n1}',
  'Не удалось посчитать потребность по {n1} {n2} — в плане их нет:': '{n1} {n2} bo‘yicha ehtiyojni hisoblab bo‘lmadi — rejada ular yo‘q:',
  'оп. {n1}: {n2}': 'op. {n1}: {n2}',
  'Не хватит на остаток заказа: {n1}. Оформите поступление на участок': 'Buyurtma qoldig‘iga yetmaydi: {n1}. Uchastkaga kirimni rasmiylashtiring',
  '{n1} · правка содержимого': '{n1} · mazmunni tahrirlash',
  'Количество{n1}': 'Miqdor{n1}',
  'Показано {n1} из {n2} причин · всего {n3}': '{n2} sababdan {n1} tasi ko‘rsatilgan · jami {n3}',
  'Всего {n1}': 'Jami {n1}',
  'Нет причин в категориях: {n1} — соответствующее действие в цехе выполнить не удастся': 'Toifalarda sabablar yo‘q: {n1} — sexda tegishli amalni bajarib bo‘lmaydi',
  'Ссылка на несуществующую операцию: {n1}. Поправьте связи или верните прежние номера': 'Mavjud bo‘lmagan operatsiyaga havola: {n1}. Bog‘lanishlarni to‘g‘rilang yoki avvalgi raqamlarni qaytaring',
  'сходятся {n1} потока': '{n1} oqim birlashadi',
  '{n1} на': '{n1} ga',
  'Обозначение «{n1}» уже есть в этой операции — по нему собирается протокол': '«{n1}» belgilanishi bu operatsiyada allaqachon bor — bayonnoma shu bo‘yicha yig‘iladi',
  'Сохранить{n1}': 'Saqlash{n1}',
  'Осталось настроить: {n1}': 'Sozlash qoldi: {n1}',
  '· правил {n1}': '· qoidalar {n1}',
  'Станков без терминала: {n1} ({n2}{n3}) — на них некому отчитываться о выпуске': 'Terminalsiz dastgohlar: {n1} ({n2}{n3}) — ularda mahsulot haqida hisobot beradigan odam yo‘q',
  'закреплён {n1}': 'biriktirilgan {n1}',
  'Без табельного номера: {n1} — такой оператор не войдёт на цеховом терминале': 'Tabel raqamisiz: {n1} — bunday operator sex terminaliga kira olmaydi',
  'вместимость {n1}': 'sig‘imi {n1}',
  'Без активной карты: {n1} — заказ по такому изделию не согласуется': 'Faol xaritasiz: {n1} — bunday mahsulot bo‘yicha buyurtma kelishilmaydi',
  'версий: {n1}': 'versiyalar: {n1}',
  '{n1} оп.': '{n1} op.',
  '{n1} ч {n2} м': '{n1} s {n2} d',
  '{n1} мин': '{n1} daq.',
  '{n1} от {n2}': '{n1}, {n2} dan',
  'Мешает выдаче: {n1}': 'Berishga xalaqit beradi: {n1}',
  'был {n1}': 'edi {n1}',
  'Не заполнено с нормой: {n1}': 'Norma bilan to‘ldirilmagan: {n1}',
  'По химии подходит «{n1}»': 'Kimyo bo‘yicha «{n1}» mos keladi',
  'Вне нормы: {n1}': 'Me’yordan tashqari: {n1}',
  'сейчас {n1}': 'hozir {n1}',
  'всего в очереди {n1}': 'navbatda jami {n1}',
  'станков в работе {n1}': 'ishdagi dastgohlar {n1}',
  'просрочено {n1}': 'muddati o‘tgan {n1}',
  'скоро {n1}': 'yaqinda {n1}',
  'всего {n1}': 'jami {n1}',
  'исчерпан ресурс {n1}': 'resurs tugagan {n1}',
  'на станках {n1} из {n2}': '{n2} dan {n1} tasi dastgohlarda',
  'из {n1}': '{n1} dan',
  'Ресурс начнётся заново: переточка возвращает кромку. Останется переточек: {n1}': 'Resurs qaytadan boshlanadi: qayta charxlash qirrani tiklaydi. Qayta charxlash qoladi: {n1}',
  '· станков {n1}': '· dastgohlar {n1}',
  '· обновлено {n1}': '· yangilandi {n1}',
  '{n1} {n2} с выпуском': '{n1} {n2} mahsulot bilan',
  '{n1} в расчёте': '{n1} hisobda',
  'Д {n1} · П {n2} · К {n3}': 'M {n1} · U {n2} · S {n3}',
  'Без расчёта: {n1} — не работали или нет нормативов': 'Hisobsiz: {n1} — ishlamagan yoki normalar yo‘q',
  '{n1} ед.': '{n1} birl.',
  'разнесено {n1}': 'taqsimlangan {n1}',
  'Разнесено {n1} из {n2} ед. Пока происхождение причин не проставлено и партии не указаны, таблица говорит больше о полноте ввода, чем о сменах': '{n2} birlikdan {n1} tasi taqsimlangan. Sabablarning kelib chiqishi qo‘yilmagan va partiyalar ko‘rsatilmagan ekan, jadval smenalar haqida emas, kiritishning to‘liqligi haqida ko‘proq gapiradi',
  'вне рецепта {n1} из {n2}': 'retseptdan tashqari {n2} dan {n1} tasi',
  'Под угрозой срока: {n1}': 'Muddat xavf ostida: {n1}',
  '· упирается в {n1}{n2}': '· {n1}{n2} ga tiralgan',
  ': нет норматива на {n1}': ': {n1} ga norma yo‘q',
  'Смена {n1} мин, очередь по правилу «{n2}».': 'Smena {n1} daq., navbat «{n2}» qoidasi bo‘yicha.',
  'Цех идёт к нормативу с коэффициентом {n1}': 'Sex normaga {n1} koeffitsiyenti bilan boradi',
  '(по {n1} закрытым операциям за две недели)': '(ikki hafta ichida yopilgan {n1} operatsiya bo‘yicha)',
  'Норматив не из маршрута: {n1}.': 'Norma marshrutdan emas: {n1}.',
  'Окно — {n1} {n2}, завершённых операций в нём {n3}.': 'Oyna — {n1} {n2}, undagi yakunlangan operatsiyalar {n3}.',
  'На плановый ремонт снято {n1}% мощности станков.': 'Rejali ta’mirga dastgohlar quvvatining {n1}% i olingan.',
  'Пропущено нерабочих смен: {n1}': 'O‘tkazib yuborilgan ishlamaydigan smenalar: {n1}',
  'Горизонт расчёта — {n1} {n2} вперёд; дальше даты не считаются.': 'Hisob ufqi — {n1} {n2} oldinga; undan nariga sanalar hisoblanmaydi.',
  'Не учитывается: {n1}.': 'Hisobga olinmaydi: {n1}.',
  'план {n1}': 'reja {n1}',
  'Предъявлено на контроль: {n1}': 'Nazoratga taqdim etilgan: {n1}',
  '· открытых несоответствий {n1}': '· ochiq nomuvofiqliklar {n1}',
  'стоп {n1}': 'to‘xtash {n1}',
  '{n1} · характеристик {n2} · предъявлено {n3}': '{n1} · tavsiflar {n2} · taqdim etilgan {n3}',
  'Неразобранные отклонения: {n1}. Брак и дефект сдавать можно — решение по несоответствию принимает мастер': 'Ko‘rib chiqilmagan chetlanishlar: {n1}. Yaroqsiz va nuqsonni topshirish mumkin — nomuvofiqlik bo‘yicha qarorni smena boshlig‘i qabul qiladi',
  'ещё {n1}': 'yana {n1}',
  'открытых {n1}': 'ochiq {n1}',
  '{n1} · загрузок {n2}': '{n1} · yuklamalar {n2}',
  '{n1} {n2} сделаны не здесь': '{n1} {n2} bu yerda qilinmagan',
  '— это {n1}% бункера.': '— bu bunkerning {n1}% i.',
  '{n1} · смена {n2}': '{n1} · smena {n2}',
  '{n1} · {n2} · сейчас {n3}': '{n1} · {n2} · hozir {n3}',
  'На операциях больше, чем по терминалу: {n1} Утверждаются часы из столбца «Утверждено» — проставьте их вручную, иначе смена закроется с недосчитанным временем.': 'Operatsiyalarda terminaldagidan ko‘p: {n1} «Tasdiqlangan» ustunidagi soatlar tasdiqlanadi — ularni qo‘lda qo‘ying, aks holda smena vaqti kam hisoblangan holda yopiladi.',
  'Простои без причины: {n1}': 'Sababsiz to‘xtashlar: {n1}',
  'Закрыта {n1}, {n2}.': 'Yopilgan {n1}, {n2}.',
  'Примечание: {n1}': 'Eslatma: {n1}',
  'Отрицательный остаток: {n1}': 'Manfiy qoldiq: {n1}',
  '{n1} в {n2}:': '{n2} da {n1}:',
  'Ниже минимума: {n1}': 'Eng kamidan past: {n1}',
  'при минимуме {n1}': 'eng kami {n1} bo‘lganda',
  'позиций {n1}': 'pozitsiyalar {n1}',
  'обновлено {n1}': 'yangilandi {n1}',
  '{n1} — выйти': '{n1} — chiqish',
  'Принято {n1}. Ждёт приёмки ещё {n2} — операция пока не закроется': 'Qabul qilindi {n1}. Yana {n2} qabulni kutmoqda — operatsiya hozircha yopilmaydi',
  'Принято {n1}. Операцию можно закрывать': 'Qabul qilindi {n1}. Operatsiyani yopish mumkin',
  ', цель {n1}%': ', maqsad {n1}%',
  '{n1} уже в списке': '{n1} allaqachon ro‘yxatda',
  '{n1} — пустая бирка, за ней ещё нет металла': '{n1} — bo‘sh birka, uning ortida hali metall yo‘q',
  'Правка: {n1}': 'Tahrirlash: {n1}',
  'показывать отключённые ()': 'o‘chirilganlarni ko‘rsatish ()',
  'на {n1} передела назад': '{n1} bosqich orqada',
  'через {n1} передела': '{n1} bosqichdan keyin',
  'повтор через ~{n1} мин': 'takror ~{n1} daq. dan keyin',
  '{n1}{n2} п.п. к цели': 'maqsadga {n1}{n2} f.p.',
  '{n1}{n2} к цели': 'maqsadga {n1}{n2}',
  '{n1} — нажмите, чтобы сменить язык': '{n1} — tilni almashtirish uchun bosing',
  '{n1} из {n2}': '{n2} dan {n1}',
  '· серт. {n1}': '· sert. {n1}',
  'после {n1}': '{n1} dan keyin',
  'Заказ {n1}': 'Buyurtma {n1}',
  '{n1} — причина не указана': '{n1} — sabab ko‘rsatilmagan',
  'В категории «{n1}» причин нет': '«{n1}» toifasida sabablar yo‘q',
  'Маршрут {n1}': 'Marshrut {n1}',
  'оп.{n1} → {n2}': 'op.{n1} → {n2}',
  'Сохранено: {n1}': 'Saqlandi: {n1}',
  'цехов {n1}, участков {n2}, станков {n3}': 'sexlar {n1}, uchastkalar {n2}, dastgohlar {n3}',
  'брак {n1}, простои {n2}, паузы {n3}': 'yaroqsiz {n1}, to‘xtashlar {n2}, pauzalar {n3}',
  'операторов {n1}, мастеров {n2}, планировщиков {n3}': 'operatorlar {n1}, smena boshliqlari {n2}, rejalashtiruvchilar {n3}',
  'записей {n1}': 'yozuvlar {n1}',
  'Перенесено из смены {n1}: {n2}': '{n1} smenasidan ko‘chirilgan: {n2}',
  ', пропущено закрытых: {n1}': ', o‘tkazib yuborilgan yopilganlar: {n1}',
  '{n1} — нажмите, чтобы сменить': '{n1} — almashtirish uchun bosing',
  'Препятствий: {n1}. Документ уйдёт заказчику с оговоркой.': 'To‘siqlar: {n1}. Hujjat buyurtmachiga izoh bilan ketadi.',
  'Список станков не загрузился: {n1}': 'Dastgohlar ro‘yxati yuklanmadi: {n1}',
  'Регламенты станка не загрузились: {n1}': 'Dastgoh reglamentlari yuklanmadi: {n1}',
  'идёт {n1}{n2}': 'ketmoqda {n1}{n2}',
  'брак и дефект {n1}': 'yaroqsiz va nuqson {n1}',
  'цель {n1}%': 'maqsad {n1}%',
  'из {n1} произведённых': 'ishlab chiqarilgan {n1} tadan',
  'не менее {n1} {n2}': 'kami bilan {n1} {n2}',
  'не более {n1} {n2}': 'ko‘pi bilan {n1} {n2}',
  '{n1}: {n2} {n3} вне допуска {n4}': '{n1}: {n2} {n3} dopuskdan tashqari {n4}',
  'Справочник причин не загрузился: {n1}': 'Sabablar ma’lumotnomasi yuklanmadi: {n1}',
  'Выгружен период {n1} — {n2}. В файл попадают только закрытые смены': '{n1} — {n2} davri yuklandi. Faylga faqat yopilgan smenalar tushadi',
  'Не удалось выгрузить: {n1}': 'Yuklab bo‘lmadi: {n1}',
  'Смена переоткрыта. Это {n1}-е переоткрытие — стоит посмотреть на порядок закрытия': 'Smena qayta ochildi. Bu {n1}-qayta ochish — yopish tartibiga qarab chiqqan ma’qul',
  'Простой без причины: {n1} мин. Укажите причины в журнале станков': 'Sababsiz to‘xtash: {n1} daq. Sabablarni dastgohlar jurnalida ko‘rsating',
  'Создать в статусе:': 'Qaysi statusda yaratilsin:',
  ' (обязателен для этой причины)': ' (bu sabab uchun majburiy)',
  'Приёмка — с планшета или компьютера': 'Qabul — planshet yoki kompyuterdan',
  'все': 'hammasi',
  'Подтвердите действие': 'Amalni tasdiqlang',
  ' назад': ' oldin',
  'непосредственно из': 'bevosita',
  'пошло в': 'ketdi',
  'номенклатура': 'nomenklatura',
  'единицы': 'birliklar',
  'места': 'joylar',
  'от склада': 'ombordan',
  'на склад': 'omborga',
  'не задан': 'berilmagan',
  'Бирки выданы': 'Birkalar berildi',
  'Напечатайте лист и держите рулон у рабочего места': 'Varaqni chop eting va rulonni ish joyida saqlang',
  'Печатаются пустыми: металл встаёт за биркой позже': 'Bo‘sh chop etiladi: metall birka ortiga keyinroq turadi',
  'лист': 'varaq',
  'листа': 'varaq',
  'листов': 'varaq',
  'по нормам': 'normalar bo‘yicha',
  'вне норм': 'normadan tashqari',
  'Движение материала': 'Material harakati',
  'ед.': 'birl.',
  'ед': 'birl.',
  'строке нормы': 'norma qatori',
  'строкам норм': 'norma qatorlari',
  'Для заказа под клиента номер документа продаж обязателен': 'Mijoz buyurtmasi uchun sotuv hujjati raqami majburiy',
  'Внутренний заказ — ссылка на документ продаж не требуется': 'Ichki buyurtma — sotuv hujjatiga havola talab qilinmaydi',
  'Новая маршрутная карта': 'Yangi marshrut xaritasi',
  'включено': 'yoqilgan',
  'выключено': 'o‘chirilgan',
  'Свернуть': 'Yig‘ish',
  'Добавить позицию': 'Pozitsiya qo‘shish',
  'Обновить цель': 'Maqsadni yangilash',
  'В задание': 'Topshiriqqa',
  'ни разу': 'hech qachon',
  'Новый терминал': 'Yangi terminal',
  'Сохраните токен: повторно он не отображается': 'Tokenni saqlang: u qayta ko‘rsatilmaydi',
  'всё предприятие': 'butun korxona',
  'Новый пользователь': 'Yangi foydalanuvchi',
  'Новый узел дерева': 'Daraxtning yangi tuguni',
  'день': 'kun',
  'дня': 'kun',
  'дней': 'kun',
  'Скрыть допущения': 'Farazlarni yashirish',
  'На чём основан прогноз': 'Prognoz nimaga asoslangan',
  'смена': 'smena',
  'смен': 'smena',
  'станок не назначен': 'dastgoh tayinlanmagan',
  'годен': 'yaroqli',
  'не годен': 'yaroqsiz',
  'значение': 'qiymat',
  'Закрыта': 'Yopilgan',
  'На проверке': 'Tekshiruvda',
  'Утверждено при закрытии смены': 'Smena yopilganda tasdiqlangan',
  'Проверьте часы: по терминалу — это время у станка': 'Soatlarni tekshiring: terminal bo‘yicha — bu dastgoh yonidagi vaqt',
  'причина не указана': 'sabab ko‘rsatilmagan',
  'сейчас': 'hozir',
  ' · не потеря': ' · yo‘qotish emas',
  'Наладчик': 'Sozlovchi',
  'Мастер': 'Smena boshlig‘i',
  'Норматива нет: ': 'Norma yo‘q: ',
  '. Эти операции в срок не посчитаны': '. Bu operatsiyalar muddatga hisoblanmagan',
  'Сменить пароль и PIN — заполните только нужное': 'Parol va PIN ni almashtirish — faqat kerakligini to‘ldiring',
  'Учётные данные': 'Hisob ma’lumotlari',
  'Нельзя отключить себя': 'O‘zingizni o‘chirib bo‘lmaydi',
  'Последний администратор должен остаться': 'Oxirgi administrator qolishi kerak',
  'активна': 'faol',
  'версия ': 'versiya ',
  'без кода': 'kodsiz',
  '— ещё не привязан —': '— hali bog‘lanmagan —',
  'склад принял ': 'ombor qabul qildi ',
  'склад ещё не подтвердил приёмку': 'ombor qabulni hali tasdiqlamagan',
  'Выдать с оговоркой': 'Izoh bilan berish',
  'Выдать сертификат': 'Sertifikat berish',
  'Обязательно: чем объясняется выдача': 'Majburiy: berish nima bilan izohlanadi',
  'материал не указан': 'material ko‘rsatilmagan',
  ' (не отгружается)': ' (jo‘natilmaydi)',
  'без уровня': 'darajasiz',
  'есть выходы': 'chiqishlar bor',
  'Задание на смену: сначала то, что уже идёт': 'Smena topshirig‘i: avval allaqachon ketayotgani',
  'Что просрочено и что идёт прямо сейчас': 'Nimaning muddati o‘tgan va hozir nima ketmoqda',
  'У чего кончается ресурс и что где стоит': 'Nimaning resursi tugayapti va nima qayerda turibdi',
  ' дн': ' kun',
  'Что случилось': 'Nima bo‘ldi',
  'Почему списываем': 'Nega hisobdan chiqaramiz',
  'Паспорт инструмента': 'Asbob pasporti',
  'Завести оснастку': 'Asbob kiritish',
  'На операциях больше, чем по терминалу: человек работал без входа либо забыл выйти. Утверждаются часы из последнего столбца — проверьте их прежде, чем закрывать смену': 'Operatsiyalarda terminaldagidan ko‘p: odam kirmasdan ishlagan yoki chiqishni unutgan. Oxirgi ustundagi soatlar tasdiqlanadi — smenani yopishdan oldin ularni tekshiring',
  'работа / плановое время': 'ish / rejali vaqt',
  'норматив / время работы': 'norma / ish vaqti',
  'годное / произведённое': 'yaroqli / ishlab chiqarilgan',
  'За период выпуск не регистрировался': 'Davr uchun mahsulot qayd etilmagan',
  'Причины отключаются свободно: смысл в том, чтобы убрать причину из выбора, сохранив её в уже зарегистрированных отчётах.': 'Sabablar erkin o‘chiriladi: maqsad — sababni tanlovdan olib tashlash va uni allaqachon qayd etilgan hisobotlarda saqlab qolish.',
  'ТЦ-05 · Токарный ЧПУ': 'ТЦ-05 · Tokarlik ChPU',
  'ООО «Ротор»': '«Rotor» MChJ',
  'Диаметр 40h7': 'Diametr 40h7',
  'Иванов А.П.': 'Aliyev S.N.',
  'Смена A (дневная)': 'Smena A (kunduzgi)',
  'Корпус КД-100': 'Korpus KD-100',
  'Круг 40 ст.45': 'Doira 40 po‘lat 45',
  'Медь': 'Mis',
  'Токарная обработка': 'Tokarlik ishlov berish',
  'Отложено': 'Kechiktirilgan',
  'Похоже на повтор уже учтённого расхода. Принято, но не применено — решает человек': 'Allaqachon hisobga olingan sarfning takroriga o‘xshaydi. Qabul qilindi, lekin qo‘llanilmadi — qarorni odam qabul qiladi',
  'Это не повтор — списать материал': 'Bu takror emas — materialni hisobdan chiqarish',
  'Это повтор — ничего не списывать': 'Bu takror — hech nima hisobdan chiqarilmasin',
  'Это повтор': 'Bu takror',
  'Это повтор?': 'Bu takrormi?',
  'Расход не будет списан. Запись останется в журнале с вашим объяснением.': 'Sarf hisobdan chiqarilmaydi. Yozuv jurnalda sizning izohingiz bilan qoladi.',
  'Почему это повтор': 'Nega bu takror',
  'Например: кладовщик отправил заново после обрыва': 'Masalan: omborchi uzilishdan keyin qayta yubordi',
  'Не списывать': 'Hisobdan chiqarilmasin',
  'Возвратные отходы': 'Qaytariladigan chiqindi',
  'Отходы': 'Chiqindi',
  'Отходы, кг': 'Chiqindi, kg',
  'Отходов на 1000 годного': '1000 yaroqliga chiqindi',
  'Отношение к годному, умноженное на тысячу: в килограммах это кг на тонну': 'Yaroqliga nisbatan, mingga ko‘paytirilgan: kilogrammda bu tonnaga kg',
  'Годное': 'Yaroqli',
  'бухту': 'g‘altak',
  'в бухте': 'g‘altakda',
  'Норма на бухту задана, а вес бухты — нет. Карта сохранится, но расход по этой строке списываться не будет, пока вес не появится': 'G‘altakka norma berilgan, g‘altak vazni esa yo‘q. Karta saqlanadi, lekin vazn paydo bo‘lguncha bu satr bo‘yicha sarf hisobdan chiqarilmaydi',
  'Бланк приёма-сдачи смены': 'Smenani topshirish-qabul qilish blankasi',
  'Бланк на случай обрыва': 'Aloqa uzilgan holat uchun blanka',
  'Печатается заранее и лежит в кабинете: когда связи нет, печатать уже негде': 'Oldindan chop etiladi va kabinetda turadi: aloqa yo‘qolganda chop etadigan joy qolmaydi',
  'Заполняется, когда система недоступна. Записи с листа вводятся в систему, как только связь вернётся': 'Tizim ishlamaganda to‘ldiriladi. Varaqdagi yozuvlar aloqa tiklanishi bilan tizimga kiritiladi',
  'Оп.': 'Op.',
  'Бирка партии': 'Partiya birkasi',
  'Причина брака': 'Yaroqsizlik sababi',
  'Конец': 'Tugash',
  'Прочее: вызовы, переналадки, происшествия': 'Boshqasi: chaqiruvlar, qayta sozlashlar, hodisalar',
  'Смену сдал': 'Smenani topshirdi',
  'Смену принял': 'Smenani qabul qildi',
  'Введено в систему: кто и когда': 'Tizimga kiritildi: kim va qachon',
  'поддон': 'poddon',
  '{n1}: по числу бухт на поддоне': '{n1}: poddondagi g‘altaklar soni bo‘yicha',
  'материал': 'material',
  'бухт →': 'g‘altak →',
  '+ строка': '+ qator',
  'Без таблицы норма одна на любой поддон — число в строке выше': 'Jadvalsiz norma har qanday poddon uchun bitta — yuqoridagi satrdagi son',
  'Тара на бухту и на поддон списывается отметкой «Поддон собран» на терминале, а не сдачей выпуска': 'G‘altak va poddonga idish mahsulot topshirish bilan emas, terminaldagi «Poddon yig‘ildi» belgisi bilan hisobdan chiqariladi',
  'Годного, т': 'Yaroqli, t',
  'Произведено, т': 'Ishlab chiqarilgan, t',
  'Масса единицы задаётся у операции или у изделия в номенклатуре': 'Birlik massasi operatsiyada yoki nomenklaturadagi mahsulotda beriladi',
  'Без массы — не в тоннах': 'Massasiz — tonnada emas',
  'из {n1} произведённых · {n2} т годного': '{n1} ishlab chiqarilgandan · {n2} t yaroqli',
  'Телефон — только просмотр. Изменения делаются с планшета или компьютера': 'Telefon — faqat ko‘rish. O‘zgartirishlar planshet yoki kompyuterdan qilinadi',
  'запас в сменах: {n1}': 'smenalardagi zaxira: {n1}',
  ', запас в сменах: {n1}': ', smenalardagi zaxira: {n1}',
  '{n1} · смен: {n2}': '{n1} · smenalar: {n2}',
};
